/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * Creative Adapt API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptInviteRequest,
  ActivityItem,
  AdaptiveLocationAccess,
  AdaptiveLocationOverview,
  AddAssignmentRequest,
  AdjustTextOverlayRequest,
  AdminAccountTopupPricingResponse,
  AdminAffiliatePayoutList,
  AdminAffiliateProgramRequest,
  AdminAffiliateProgramResponse,
  AdminAffiliateStatus,
  AdminAffiliateStatusRequest,
  AdminChangeRoleRequest,
  AdminClientDetail,
  AdminClientListResponse,
  AdminConfirmOrderResponse,
  AdminContactHandledRequest,
  AdminContactMessage,
  AdminContactMessagesResponse,
  AdminCountResponse,
  AdminCreatePresetRequest,
  AdminCreditAdjustRequest,
  AdminCreditAdjustResponse,
  AdminFeatureFlagsRequest,
  AdminFeatureFlagsResponse,
  AdminGetClientUsageParams,
  AdminHardDeleteUserResponse,
  AdminInviteMemberRequest,
  AdminInviteMemberResponse,
  AdminIssueVatInvoiceRequest,
  AdminIssueVatInvoiceResponse,
  AdminListAffiliatePayoutsParams,
  AdminListClientsParams,
  AdminListContactMessagesParams,
  AdminListVatInvoicesParams,
  AdminLockRequest,
  AdminMarkPayoutPaidRequest,
  AdminPreset,
  AdminPresetsResponse,
  AdminReconciliationResponse,
  AdminReferralOverview,
  AdminReferralRewardsRequest,
  AdminReferralRewardsResponse,
  AdminRefundRequest,
  AdminRefundResponse,
  AdminRejectPayoutRequest,
  AdminReports,
  AdminResendVerificationResponse,
  AdminSetPasswordRequest,
  AdminSetPasswordResponse,
  AdminSetSeatsRequest,
  AdminSetSeatsResponse,
  AdminSettings,
  AdminTaskCostsRequest,
  AdminTaskCostsResponse,
  AdminTopupPricingRequest,
  AdminTopupPricingResponse,
  AdminUpdatePresetRequest,
  AdminUpdateSubscriptionRequest,
  AdminUsageHistory,
  AdminVatInvoiceListResponse,
  AdminWelcomeTrialCreditsRequest,
  AdminWelcomeTrialCreditsResponse,
  AffiliateOverview,
  AffiliatePayoutCreated,
  AffiliatePayoutRequestBody,
  AffiliatePayoutSettlement,
  ApproveCustomerRequest,
  Asset,
  AssetAssignment,
  AssetDetail,
  AssetVersion,
  AuthUser,
  AutoRenewResponse,
  BboxCropTelemetry,
  BboxCropTelemetryHistory,
  ChangePasswordRequest,
  ClassificationSummary,
  ConsentState,
  ContactMessageResult,
  CreateInviteRequest,
  CreateOrderRequest,
  CreateUploadNudgeDismissResponse,
  CreditBalance,
  CreditUsageResponse,
  CustomerAssetDetail,
  CustomerAssetSummary,
  CustomerCandidate,
  CustomerFeedbackState,
  CustomerLockRequest,
  CustomerLockResult,
  DashboardSummary,
  DeleteAccountRequest,
  DownloadOrderInvoiceParams,
  EditDraft,
  EditState,
  FeedbackActivity,
  FeedbackOverview,
  FeedbackSession,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  GenerateRequest,
  GetBboxCropTelemetryHistoryParams,
  GetCreditUsageParams,
  GetCustomerFeedbackStateParams,
  GetEditStateParams,
  GetNotificationUnreadCount200,
  HealthStatus,
  InviteListResponse,
  InvitePublic,
  InviteResponse,
  Job,
  Layer,
  LayerClassificationUpdate,
  LayerUpdate,
  ListAssetsParams,
  ListCustomerAssetsParams,
  ListEditVersionsParams,
  ListNotificationsParams,
  ListOrdersParams,
  ListVnNewProvincesParams,
  ListVnNewWardsParams,
  ListVnOldDistrictsParams,
  ListVnOldProvincesParams,
  ListVnOldWardsParams,
  LoginRequest,
  MarkNotificationsReadRequest,
  MeAccountResponse,
  NewAsset,
  NewContactMessage,
  NewPreset,
  Notification,
  OkResponse,
  Order,
  OrderListResponse,
  Output,
  PaymentWebhookRequest,
  PaymentWebhookResult,
  PlatformOutputGroup,
  Preset,
  PresetUpdate,
  PresetVersionSummary,
  ProposeLayoutRequest,
  ProposeLayoutResponse,
  PurchasingCatalog,
  ReanalyzeBboxRequest,
  ReanalyzeBboxResponse,
  ReferralCodeLookup,
  ReferralOverview,
  RegenerateEditRequest,
  RegenerateEditResponse,
  RegisterBusinessRequest,
  RegisterResponse,
  RegisterSingleRequest,
  ReleaseCustomerLockParams,
  ResendVerificationRequest,
  ResendVerificationResponse,
  ResetPasswordRequest,
  RevertLayerClassification409,
  SaveAsVersionRequest,
  SaveCustomerDraftRequest,
  SaveEditDraftRequest,
  SendCustomerFeedbackRequest,
  SendForReviewRequest,
  SetAutoRenewRequest,
  SetMarketingConsent200,
  SetMarketingConsentBody,
  UpdateCurrentUserBody,
  UploadUrlRequest,
  UploadUrlResponseData,
  VatInvoiceDetails,
  VatProfileResponse,
  VerifyEmailRequest,
  VnAddressSyncStartResponse,
  VnAddressSyncStatusResponse,
  VnNewProvince,
  VnNewWard,
  VnOldDistrict,
  VnOldProvince,
  VnOldWard,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Returns the current logged-in user
 */
export const getGetCurrentUserUrl = () => {
  return `/api/auth/me`;
};

export const getCurrentUser = async (
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getGetCurrentUserUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCurrentUserQueryKey = () => {
  return [`/api/auth/me`] as const;
};

export const getGetCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUser>>> = ({
    signal,
  }) => getCurrentUser({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUser>>
>;
export type GetCurrentUserQueryError = ErrorType<void>;

/**
 * @summary Returns the current logged-in user
 */

export function useGetCurrentUser<
  TData = Awaited<ReturnType<typeof getCurrentUser>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUser>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update display name of the current user
 */
export const getUpdateCurrentUserUrl = () => {
  return `/api/auth/me`;
};

export const updateCurrentUser = async (
  updateCurrentUserBody: UpdateCurrentUserBody,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getUpdateCurrentUserUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateCurrentUserBody),
  });
};

export const getUpdateCurrentUserMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    TError,
    { data: BodyType<UpdateCurrentUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentUser>>,
  TError,
  { data: BodyType<UpdateCurrentUserBody> },
  TContext
> => {
  const mutationKey = ["updateCurrentUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    { data: BodyType<UpdateCurrentUserBody> }
  > = (props) => {
    const { data } = props ?? {};

    return updateCurrentUser(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentUser>>
>;
export type UpdateCurrentUserMutationBody = BodyType<UpdateCurrentUserBody>;
export type UpdateCurrentUserMutationError = ErrorType<void>;

/**
 * @summary Update display name of the current user
 */
export const useUpdateCurrentUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUser>>,
    TError,
    { data: BodyType<UpdateCurrentUserBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentUser>>,
  TError,
  { data: BodyType<UpdateCurrentUserBody> },
  TContext
> => {
  return useMutation(getUpdateCurrentUserMutationOptions(options));
};

/**
 * @summary Change the current user's password (verifies the current password first)
 */
export const getChangeMyPasswordUrl = () => {
  return `/api/auth/me/password`;
};

export const changeMyPassword = async (
  changePasswordRequest: ChangePasswordRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getChangeMyPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(changePasswordRequest),
  });
};

export const getChangeMyPasswordMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeMyPassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof changeMyPassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  const mutationKey = ["changeMyPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof changeMyPassword>>,
    { data: BodyType<ChangePasswordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return changeMyPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChangeMyPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof changeMyPassword>>
>;
export type ChangeMyPasswordMutationBody = BodyType<ChangePasswordRequest>;
export type ChangeMyPasswordMutationError = ErrorType<void>;

/**
 * @summary Change the current user's password (verifies the current password first)
 */
export const useChangeMyPassword = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof changeMyPassword>>,
    TError,
    { data: BodyType<ChangePasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof changeMyPassword>>,
  TError,
  { data: BodyType<ChangePasswordRequest> },
  TContext
> => {
  return useMutation(getChangeMyPasswordMutationOptions(options));
};

/**
 * @summary Permanently delete the current user's account and personal data (password-confirmed)
 */
export const getDeleteMyAccountUrl = () => {
  return `/api/auth/me/delete-account`;
};

export const deleteMyAccount = async (
  deleteAccountRequest: DeleteAccountRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteMyAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(deleteAccountRequest),
  });
};

export const getDeleteMyAccountMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyAccount>>,
    TError,
    { data: BodyType<DeleteAccountRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMyAccount>>,
  TError,
  { data: BodyType<DeleteAccountRequest> },
  TContext
> => {
  const mutationKey = ["deleteMyAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMyAccount>>,
    { data: BodyType<DeleteAccountRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return deleteMyAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMyAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMyAccount>>
>;
export type DeleteMyAccountMutationBody = BodyType<DeleteAccountRequest>;
export type DeleteMyAccountMutationError = ErrorType<void>;

/**
 * @summary Permanently delete the current user's account and personal data (password-confirmed)
 */
export const useDeleteMyAccount = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMyAccount>>,
    TError,
    { data: BodyType<DeleteAccountRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMyAccount>>,
  TError,
  { data: BodyType<DeleteAccountRequest> },
  TContext
> => {
  return useMutation(getDeleteMyAccountMutationOptions(options));
};

/**
 * @summary Download a ZIP of all personal data stored about the current user (GDPR right of access)
 */
export const getExportMyDataUrl = () => {
  return `/api/auth/me/export`;
};

export const exportMyData = async (options?: RequestInit): Promise<Blob> => {
  return customFetch<Blob>(getExportMyDataUrl(), {
    ...options,
    method: "GET",
  });
};

export const getExportMyDataQueryKey = () => {
  return [`/api/auth/me/export`] as const;
};

export const getExportMyDataQueryOptions = <
  TData = Awaited<ReturnType<typeof exportMyData>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportMyData>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExportMyDataQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof exportMyData>>> = ({
    signal,
  }) => exportMyData({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportMyData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExportMyDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportMyData>>
>;
export type ExportMyDataQueryError = ErrorType<void>;

/**
 * @summary Download a ZIP of all personal data stored about the current user (GDPR right of access)
 */

export function useExportMyData<
  TData = Awaited<ReturnType<typeof exportMyData>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof exportMyData>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getExportMyDataQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary The current user's consent state (terms acceptance + marketing consent)
 */
export const getGetMyConsentsUrl = () => {
  return `/api/auth/me/consents`;
};

export const getMyConsents = async (
  options?: RequestInit,
): Promise<ConsentState> => {
  return customFetch<ConsentState>(getGetMyConsentsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyConsentsQueryKey = () => {
  return [`/api/auth/me/consents`] as const;
};

export const getGetMyConsentsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyConsents>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyConsents>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyConsentsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyConsents>>> = ({
    signal,
  }) => getMyConsents({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyConsents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyConsentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyConsents>>
>;
export type GetMyConsentsQueryError = ErrorType<void>;

/**
 * @summary The current user's consent state (terms acceptance + marketing consent)
 */

export function useGetMyConsents<
  TData = Awaited<ReturnType<typeof getMyConsents>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyConsents>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyConsentsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Grant or withdraw marketing-communication consent (every change is recorded)
 */
export const getSetMarketingConsentUrl = () => {
  return `/api/auth/me/consents/marketing`;
};

export const setMarketingConsent = async (
  setMarketingConsentBody: SetMarketingConsentBody,
  options?: RequestInit,
): Promise<SetMarketingConsent200> => {
  return customFetch<SetMarketingConsent200>(getSetMarketingConsentUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setMarketingConsentBody),
  });
};

export const getSetMarketingConsentMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMarketingConsent>>,
    TError,
    { data: BodyType<SetMarketingConsentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setMarketingConsent>>,
  TError,
  { data: BodyType<SetMarketingConsentBody> },
  TContext
> => {
  const mutationKey = ["setMarketingConsent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setMarketingConsent>>,
    { data: BodyType<SetMarketingConsentBody> }
  > = (props) => {
    const { data } = props ?? {};

    return setMarketingConsent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetMarketingConsentMutationResult = NonNullable<
  Awaited<ReturnType<typeof setMarketingConsent>>
>;
export type SetMarketingConsentMutationBody = BodyType<SetMarketingConsentBody>;
export type SetMarketingConsentMutationError = ErrorType<void>;

/**
 * @summary Grant or withdraw marketing-communication consent (every change is recorded)
 */
export const useSetMarketingConsent = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setMarketingConsent>>,
    TError,
    { data: BodyType<SetMarketingConsentBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setMarketingConsent>>,
  TError,
  { data: BodyType<SetMarketingConsentBody> },
  TContext
> => {
  return useMutation(getSetMarketingConsentMutationOptions(options));
};

/**
 * @summary Log in with username and password (sets session cookie)
 */
export const getLoginUrl = () => {
  return `/api/auth/login`;
};

export const login = async (
  loginRequest: LoginRequest,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginRequest),
  });
};

export const getLoginMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  const mutationKey = ["login"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { data: BodyType<LoginRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return login(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = BodyType<LoginRequest>;
export type LoginMutationError = ErrorType<void>;

/**
 * @summary Log in with username and password (sets session cookie)
 */
export const useLogin = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { data: BodyType<LoginRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof login>>,
  TError,
  { data: BodyType<LoginRequest> },
  TContext
> => {
  return useMutation(getLoginMutationOptions(options));
};

/**
 * @summary Clear session cookie
 */
export const getLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const logout = async (options?: RequestInit): Promise<OkResponse> => {
  return customFetch<OkResponse>(getLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["logout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    void
  > = () => {
    return logout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = ErrorType<unknown>;

/**
 * @summary Clear session cookie
 */
export const useLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof logout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getLogoutMutationOptions(options));
};

/**
 * @summary Register a personal (SINGLE) account
 */
export const getRegisterSingleUrl = () => {
  return `/api/auth/register/single`;
};

export const registerSingle = async (
  registerSingleRequest: RegisterSingleRequest,
  options?: RequestInit,
): Promise<RegisterResponse> => {
  return customFetch<RegisterResponse>(getRegisterSingleUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerSingleRequest),
  });
};

export const getRegisterSingleMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerSingle>>,
    TError,
    { data: BodyType<RegisterSingleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerSingle>>,
  TError,
  { data: BodyType<RegisterSingleRequest> },
  TContext
> => {
  const mutationKey = ["registerSingle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerSingle>>,
    { data: BodyType<RegisterSingleRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return registerSingle(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterSingleMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerSingle>>
>;
export type RegisterSingleMutationBody = BodyType<RegisterSingleRequest>;
export type RegisterSingleMutationError = ErrorType<void>;

/**
 * @summary Register a personal (SINGLE) account
 */
export const useRegisterSingle = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerSingle>>,
    TError,
    { data: BodyType<RegisterSingleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerSingle>>,
  TError,
  { data: BodyType<RegisterSingleRequest> },
  TContext
> => {
  return useMutation(getRegisterSingleMutationOptions(options));
};

/**
 * @summary Register a business (BUSINESS) account
 */
export const getRegisterBusinessUrl = () => {
  return `/api/auth/register/business`;
};

export const registerBusiness = async (
  registerBusinessRequest: RegisterBusinessRequest,
  options?: RequestInit,
): Promise<RegisterResponse> => {
  return customFetch<RegisterResponse>(getRegisterBusinessUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(registerBusinessRequest),
  });
};

export const getRegisterBusinessMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerBusiness>>,
    TError,
    { data: BodyType<RegisterBusinessRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerBusiness>>,
  TError,
  { data: BodyType<RegisterBusinessRequest> },
  TContext
> => {
  const mutationKey = ["registerBusiness"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerBusiness>>,
    { data: BodyType<RegisterBusinessRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return registerBusiness(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterBusinessMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerBusiness>>
>;
export type RegisterBusinessMutationBody = BodyType<RegisterBusinessRequest>;
export type RegisterBusinessMutationError = ErrorType<void>;

/**
 * @summary Register a business (BUSINESS) account
 */
export const useRegisterBusiness = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerBusiness>>,
    TError,
    { data: BodyType<RegisterBusinessRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerBusiness>>,
  TError,
  { data: BodyType<RegisterBusinessRequest> },
  TContext
> => {
  return useMutation(getRegisterBusinessMutationOptions(options));
};

/**
 * @summary Verify an email with the 6-digit OTP (sets session cookie)
 */
export const getVerifyEmailUrl = () => {
  return `/api/auth/verify-email`;
};

export const verifyEmail = async (
  verifyEmailRequest: VerifyEmailRequest,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getVerifyEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(verifyEmailRequest),
  });
};

export const getVerifyEmailMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmail>>,
    TError,
    { data: BodyType<VerifyEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof verifyEmail>>,
  TError,
  { data: BodyType<VerifyEmailRequest> },
  TContext
> => {
  const mutationKey = ["verifyEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof verifyEmail>>,
    { data: BodyType<VerifyEmailRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return verifyEmail(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type VerifyEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof verifyEmail>>
>;
export type VerifyEmailMutationBody = BodyType<VerifyEmailRequest>;
export type VerifyEmailMutationError = ErrorType<void>;

/**
 * @summary Verify an email with the 6-digit OTP (sets session cookie)
 */
export const useVerifyEmail = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof verifyEmail>>,
    TError,
    { data: BodyType<VerifyEmailRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof verifyEmail>>,
  TError,
  { data: BodyType<VerifyEmailRequest> },
  TContext
> => {
  return useMutation(getVerifyEmailMutationOptions(options));
};

/**
 * @summary Re-issue an email verification code
 */
export const getResendVerificationUrl = () => {
  return `/api/auth/resend-verification`;
};

export const resendVerification = async (
  resendVerificationRequest: ResendVerificationRequest,
  options?: RequestInit,
): Promise<ResendVerificationResponse> => {
  return customFetch<ResendVerificationResponse>(getResendVerificationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resendVerificationRequest),
  });
};

export const getResendVerificationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendVerification>>,
    TError,
    { data: BodyType<ResendVerificationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendVerification>>,
  TError,
  { data: BodyType<ResendVerificationRequest> },
  TContext
> => {
  const mutationKey = ["resendVerification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendVerification>>,
    { data: BodyType<ResendVerificationRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return resendVerification(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendVerification>>
>;
export type ResendVerificationMutationBody =
  BodyType<ResendVerificationRequest>;
export type ResendVerificationMutationError = ErrorType<unknown>;

/**
 * @summary Re-issue an email verification code
 */
export const useResendVerification = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendVerification>>,
    TError,
    { data: BodyType<ResendVerificationRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendVerification>>,
  TError,
  { data: BodyType<ResendVerificationRequest> },
  TContext
> => {
  return useMutation(getResendVerificationMutationOptions(options));
};

/**
 * @summary Request a password-reset code (always succeeds; never reveals if the email exists)
 */
export const getForgotPasswordUrl = () => {
  return `/api/auth/forgot-password`;
};

export const forgotPassword = async (
  forgotPasswordRequest: ForgotPasswordRequest,
  options?: RequestInit,
): Promise<ForgotPasswordResponse> => {
  return customFetch<ForgotPasswordResponse>(getForgotPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(forgotPasswordRequest),
  });
};

export const getForgotPasswordMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { data: BodyType<ForgotPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { data: BodyType<ForgotPasswordRequest> },
  TContext
> => {
  const mutationKey = ["forgotPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPassword>>,
    { data: BodyType<ForgotPasswordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return forgotPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof forgotPassword>>
>;
export type ForgotPasswordMutationBody = BodyType<ForgotPasswordRequest>;
export type ForgotPasswordMutationError = ErrorType<void>;

/**
 * @summary Request a password-reset code (always succeeds; never reveals if the email exists)
 */
export const useForgotPassword = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { data: BodyType<ForgotPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { data: BodyType<ForgotPasswordRequest> },
  TContext
> => {
  return useMutation(getForgotPasswordMutationOptions(options));
};

/**
 * @summary Reset a password using the 6-digit reset code
 */
export const getResetPasswordUrl = () => {
  return `/api/auth/reset-password`;
};

export const resetPassword = async (
  resetPasswordRequest: ResetPasswordRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getResetPasswordUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(resetPasswordRequest),
  });
};

export const getResetPasswordMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: BodyType<ResetPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  { data: BodyType<ResetPasswordRequest> },
  TContext
> => {
  const mutationKey = ["resetPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetPassword>>,
    { data: BodyType<ResetPasswordRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return resetPassword(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetPassword>>
>;
export type ResetPasswordMutationBody = BodyType<ResetPasswordRequest>;
export type ResetPasswordMutationError = ErrorType<void>;

/**
 * @summary Reset a password using the 6-digit reset code
 */
export const useResetPassword = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetPassword>>,
    TError,
    { data: BodyType<ResetPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetPassword>>,
  TError,
  { data: BodyType<ResetPasswordRequest> },
  TContext
> => {
  return useMutation(getResetPasswordMutationOptions(options));
};

/**
 * @summary Invite a member to the current BUSINESS account
 */
export const getCreateInviteUrl = () => {
  return `/api/auth/invites`;
};

export const createInvite = async (
  createInviteRequest: CreateInviteRequest,
  options?: RequestInit,
): Promise<InviteResponse> => {
  return customFetch<InviteResponse>(getCreateInviteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInviteRequest),
  });
};

export const getCreateInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvite>>,
    TError,
    { data: BodyType<CreateInviteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInvite>>,
  TError,
  { data: BodyType<CreateInviteRequest> },
  TContext
> => {
  const mutationKey = ["createInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInvite>>,
    { data: BodyType<CreateInviteRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createInvite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInvite>>
>;
export type CreateInviteMutationBody = BodyType<CreateInviteRequest>;
export type CreateInviteMutationError = ErrorType<void>;

/**
 * @summary Invite a member to the current BUSINESS account
 */
export const useCreateInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInvite>>,
    TError,
    { data: BodyType<CreateInviteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInvite>>,
  TError,
  { data: BodyType<CreateInviteRequest> },
  TContext
> => {
  return useMutation(getCreateInviteMutationOptions(options));
};

/**
 * @summary List invites for the current BUSINESS account
 */
export const getListInvitesUrl = () => {
  return `/api/auth/invites`;
};

export const listInvites = async (
  options?: RequestInit,
): Promise<InviteListResponse> => {
  return customFetch<InviteListResponse>(getListInvitesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListInvitesQueryKey = () => {
  return [`/api/auth/invites`] as const;
};

export const getListInvitesQueryOptions = <
  TData = Awaited<ReturnType<typeof listInvites>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInvites>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInvitesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvites>>> = ({
    signal,
  }) => listInvites({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInvites>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInvitesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInvites>>
>;
export type ListInvitesQueryError = ErrorType<void>;

/**
 * @summary List invites for the current BUSINESS account
 */

export function useListInvites<
  TData = Awaited<ReturnType<typeof listInvites>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listInvites>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInvitesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Look up an invite by its raw token (public)
 */
export const getGetInviteByTokenUrl = (token: string) => {
  return `/api/auth/invites/${token}`;
};

export const getInviteByToken = async (
  token: string,
  options?: RequestInit,
): Promise<InvitePublic> => {
  return customFetch<InvitePublic>(getGetInviteByTokenUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetInviteByTokenQueryKey = (token: string) => {
  return [`/api/auth/invites/${token}`] as const;
};

export const getGetInviteByTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getInviteByToken>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInviteByToken>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInviteByTokenQueryKey(token);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getInviteByToken>>
  > = ({ signal }) => getInviteByToken(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getInviteByToken>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetInviteByTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInviteByToken>>
>;
export type GetInviteByTokenQueryError = ErrorType<void>;

/**
 * @summary Look up an invite by its raw token (public)
 */

export function useGetInviteByToken<
  TData = Awaited<ReturnType<typeof getInviteByToken>>,
  TError = ErrorType<void>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInviteByToken>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInviteByTokenQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Accept a member invite and create the account (sets session cookie)
 */
export const getAcceptInviteUrl = () => {
  return `/api/auth/accept-invite`;
};

export const acceptInvite = async (
  acceptInviteRequest: AcceptInviteRequest,
  options?: RequestInit,
): Promise<AuthUser> => {
  return customFetch<AuthUser>(getAcceptInviteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(acceptInviteRequest),
  });
};

export const getAcceptInviteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvite>>,
    TError,
    { data: BodyType<AcceptInviteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptInvite>>,
  TError,
  { data: BodyType<AcceptInviteRequest> },
  TContext
> => {
  const mutationKey = ["acceptInvite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptInvite>>,
    { data: BodyType<AcceptInviteRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return acceptInvite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptInviteMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptInvite>>
>;
export type AcceptInviteMutationBody = BodyType<AcceptInviteRequest>;
export type AcceptInviteMutationError = ErrorType<void>;

/**
 * @summary Accept a member invite and create the account (sets session cookie)
 */
export const useAcceptInvite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptInvite>>,
    TError,
    { data: BodyType<AcceptInviteRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptInvite>>,
  TError,
  { data: BodyType<AcceptInviteRequest> },
  TContext
> => {
  return useMutation(getAcceptInviteMutationOptions(options));
};

/**
 * @summary Active account, role, memberships and seat usage for the current user
 */
export const getGetMyAccountUrl = () => {
  return `/api/auth/me/account`;
};

export const getMyAccount = async (
  options?: RequestInit,
): Promise<MeAccountResponse> => {
  return customFetch<MeAccountResponse>(getGetMyAccountUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMyAccountQueryKey = () => {
  return [`/api/auth/me/account`] as const;
};

export const getGetMyAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyAccount>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyAccount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyAccountQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAccount>>> = ({
    signal,
  }) => getMyAccount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyAccount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMyAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyAccount>>
>;
export type GetMyAccountQueryError = ErrorType<void>;

/**
 * @summary Active account, role, memberships and seat usage for the current user
 */

export function useGetMyAccount<
  TData = Awaited<ReturnType<typeof getMyAccount>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMyAccount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMyAccountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Available credit balance for the current user's active account
 */
export const getGetCreditBalanceUrl = () => {
  return `/api/credits/balance`;
};

export const getCreditBalance = async (
  options?: RequestInit,
): Promise<CreditBalance> => {
  return customFetch<CreditBalance>(getGetCreditBalanceUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCreditBalanceQueryKey = () => {
  return [`/api/credits/balance`] as const;
};

export const getGetCreditBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof getCreditBalance>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCreditBalance>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCreditBalanceQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCreditBalance>>
  > = ({ signal }) => getCreditBalance({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCreditBalance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCreditBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCreditBalance>>
>;
export type GetCreditBalanceQueryError = ErrorType<void>;

/**
 * @summary Available credit balance for the current user's active account
 */

export function useGetCreditBalance<
  TData = Awaited<ReturnType<typeof getCreditBalance>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCreditBalance>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCreditBalanceQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Dismiss the one-time create-upload prompt for the active account
 */
export const getDismissCreateUploadNudgeUrl = () => {
  return `/api/credits/create-upload-nudge/dismiss`;
};

export const dismissCreateUploadNudge = async (
  options?: RequestInit,
): Promise<CreateUploadNudgeDismissResponse> => {
  return customFetch<CreateUploadNudgeDismissResponse>(
    getDismissCreateUploadNudgeUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getDismissCreateUploadNudgeMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissCreateUploadNudge>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissCreateUploadNudge>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["dismissCreateUploadNudge"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissCreateUploadNudge>>,
    void
  > = () => {
    return dismissCreateUploadNudge(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissCreateUploadNudgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissCreateUploadNudge>>
>;

export type DismissCreateUploadNudgeMutationError = ErrorType<void>;

/**
 * @summary Dismiss the one-time create-upload prompt for the active account
 */
export const useDismissCreateUploadNudge = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissCreateUploadNudge>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissCreateUploadNudge>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getDismissCreateUploadNudgeMutationOptions(options));
};

/**
 * @summary The caller's referral-program overview (code, stats, referred list)
 */
export const getGetReferralOverviewUrl = () => {
  return `/api/referrals/me`;
};

export const getReferralOverview = async (
  options?: RequestInit,
): Promise<ReferralOverview> => {
  return customFetch<ReferralOverview>(getGetReferralOverviewUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetReferralOverviewQueryKey = () => {
  return [`/api/referrals/me`] as const;
};

export const getGetReferralOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getReferralOverview>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getReferralOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReferralOverviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReferralOverview>>
  > = ({ signal }) => getReferralOverview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReferralOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetReferralOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReferralOverview>>
>;
export type GetReferralOverviewQueryError = ErrorType<void>;

/**
 * @summary The caller's referral-program overview (code, stats, referred list)
 */

export function useGetReferralOverview<
  TData = Awaited<ReturnType<typeof getReferralOverview>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getReferralOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetReferralOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary The caller's affiliate dashboard (balances, ledger, payouts)
 */
export const getGetAffiliateOverviewUrl = () => {
  return `/api/affiliates/me`;
};

export const getAffiliateOverview = async (
  options?: RequestInit,
): Promise<AffiliateOverview> => {
  return customFetch<AffiliateOverview>(getGetAffiliateOverviewUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAffiliateOverviewQueryKey = () => {
  return [`/api/affiliates/me`] as const;
};

export const getGetAffiliateOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getAffiliateOverview>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAffiliateOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAffiliateOverviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAffiliateOverview>>
  > = ({ signal }) => getAffiliateOverview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAffiliateOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAffiliateOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAffiliateOverview>>
>;
export type GetAffiliateOverviewQueryError = ErrorType<void>;

/**
 * @summary The caller's affiliate dashboard (balances, ledger, payouts)
 */

export function useGetAffiliateOverview<
  TData = Awaited<ReturnType<typeof getAffiliateOverview>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAffiliateOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAffiliateOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Request a payout of the available commission balance
 */
export const getRequestAffiliatePayoutUrl = () => {
  return `/api/affiliates/me/payouts`;
};

export const requestAffiliatePayout = async (
  affiliatePayoutRequestBody: AffiliatePayoutRequestBody,
  options?: RequestInit,
): Promise<AffiliatePayoutCreated> => {
  return customFetch<AffiliatePayoutCreated>(getRequestAffiliatePayoutUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(affiliatePayoutRequestBody),
  });
};

export const getRequestAffiliatePayoutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestAffiliatePayout>>,
    TError,
    { data: BodyType<AffiliatePayoutRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestAffiliatePayout>>,
  TError,
  { data: BodyType<AffiliatePayoutRequestBody> },
  TContext
> => {
  const mutationKey = ["requestAffiliatePayout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestAffiliatePayout>>,
    { data: BodyType<AffiliatePayoutRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return requestAffiliatePayout(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestAffiliatePayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestAffiliatePayout>>
>;
export type RequestAffiliatePayoutMutationBody =
  BodyType<AffiliatePayoutRequestBody>;
export type RequestAffiliatePayoutMutationError = ErrorType<void>;

/**
 * @summary Request a payout of the available commission balance
 */
export const useRequestAffiliatePayout = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestAffiliatePayout>>,
    TError,
    { data: BodyType<AffiliatePayoutRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestAffiliatePayout>>,
  TError,
  { data: BodyType<AffiliatePayoutRequestBody> },
  TContext
> => {
  return useMutation(getRequestAffiliatePayoutMutationOptions(options));
};

/**
 * @summary Public referral-code lookup for the registration page hint
 */
export const getLookupReferralCodeUrl = (code: string) => {
  return `/api/auth/referral/${code}`;
};

export const lookupReferralCode = async (
  code: string,
  options?: RequestInit,
): Promise<ReferralCodeLookup> => {
  return customFetch<ReferralCodeLookup>(getLookupReferralCodeUrl(code), {
    ...options,
    method: "GET",
  });
};

export const getLookupReferralCodeQueryKey = (code: string) => {
  return [`/api/auth/referral/${code}`] as const;
};

export const getLookupReferralCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof lookupReferralCode>>,
  TError = ErrorType<unknown>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupReferralCode>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getLookupReferralCodeQueryKey(code);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof lookupReferralCode>>
  > = ({ signal }) => lookupReferralCode(code, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!code,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof lookupReferralCode>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type LookupReferralCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof lookupReferralCode>>
>;
export type LookupReferralCodeQueryError = ErrorType<unknown>;

/**
 * @summary Public referral-code lookup for the registration page hint
 */

export function useLookupReferralCode<
  TData = Awaited<ReturnType<typeof lookupReferralCode>>,
  TError = ErrorType<unknown>,
>(
  code: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof lookupReferralCode>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getLookupReferralCodeQueryOptions(code, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Recent credit usage events for the current user's active account
 */
export const getGetCreditUsageUrl = (params?: GetCreditUsageParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/credits/usage?${stringifiedParams}`
    : `/api/credits/usage`;
};

export const getCreditUsage = async (
  params?: GetCreditUsageParams,
  options?: RequestInit,
): Promise<CreditUsageResponse> => {
  return customFetch<CreditUsageResponse>(getGetCreditUsageUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetCreditUsageQueryKey = (params?: GetCreditUsageParams) => {
  return [`/api/credits/usage`, ...(params ? [params] : [])] as const;
};

export const getGetCreditUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getCreditUsage>>,
  TError = ErrorType<void>,
>(
  params?: GetCreditUsageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCreditUsage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCreditUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditUsage>>> = ({
    signal,
  }) => getCreditUsage(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCreditUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCreditUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCreditUsage>>
>;
export type GetCreditUsageQueryError = ErrorType<void>;

/**
 * @summary Recent credit usage events for the current user's active account
 */

export function useGetCreditUsage<
  TData = Awaited<ReturnType<typeof getCreditUsage>>,
  TError = ErrorType<void>,
>(
  params?: GetCreditUsageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCreditUsage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCreditUsageQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Purchasable subscription plans, top-up packs, and seat slot packs
 */
export const getGetPurchasingCatalogUrl = () => {
  return `/api/purchasing/catalog`;
};

export const getPurchasingCatalog = async (
  options?: RequestInit,
): Promise<PurchasingCatalog> => {
  return customFetch<PurchasingCatalog>(getGetPurchasingCatalogUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPurchasingCatalogQueryKey = () => {
  return [`/api/purchasing/catalog`] as const;
};

export const getGetPurchasingCatalogQueryOptions = <
  TData = Awaited<ReturnType<typeof getPurchasingCatalog>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPurchasingCatalog>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPurchasingCatalogQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPurchasingCatalog>>
  > = ({ signal }) => getPurchasingCatalog({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPurchasingCatalog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPurchasingCatalogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPurchasingCatalog>>
>;
export type GetPurchasingCatalogQueryError = ErrorType<void>;

/**
 * @summary Purchasable subscription plans, top-up packs, and seat slot packs
 */

export function useGetPurchasingCatalog<
  TData = Awaited<ReturnType<typeof getPurchasingCatalog>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPurchasingCatalog>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPurchasingCatalogQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the current account's orders, newest first
 */
export const getListOrdersUrl = (params?: ListOrdersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/purchasing/orders?${stringifiedParams}`
    : `/api/purchasing/orders`;
};

export const listOrders = async (
  params?: ListOrdersParams,
  options?: RequestInit,
): Promise<OrderListResponse> => {
  return customFetch<OrderListResponse>(getListOrdersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListOrdersQueryKey = (params?: ListOrdersParams) => {
  return [`/api/purchasing/orders`, ...(params ? [params] : [])] as const;
};

export const getListOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = ErrorType<void>,
>(
  params?: ListOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOrdersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOrders>>> = ({
    signal,
  }) => listOrders(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrders>>
>;
export type ListOrdersQueryError = ErrorType<void>;

/**
 * @summary List the current account's orders, newest first
 */

export function useListOrders<
  TData = Awaited<ReturnType<typeof listOrders>>,
  TError = ErrorType<void>,
>(
  params?: ListOrdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOrders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a pending order and get its QR / bank-transfer checkout info
 */
export const getCreateOrderUrl = () => {
  return `/api/purchasing/orders`;
};

export const createOrder = async (
  createOrderRequest: CreateOrderRequest,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getCreateOrderUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createOrderRequest),
  });
};

export const getCreateOrderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrder>>,
    TError,
    { data: BodyType<CreateOrderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { data: BodyType<CreateOrderRequest> },
  TContext
> => {
  const mutationKey = ["createOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrder>>,
    { data: BodyType<CreateOrderRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return createOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrder>>
>;
export type CreateOrderMutationBody = BodyType<CreateOrderRequest>;
export type CreateOrderMutationError = ErrorType<void>;

/**
 * @summary Create a pending order and get its QR / bank-transfer checkout info
 */
export const useCreateOrder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrder>>,
    TError,
    { data: BodyType<CreateOrderRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createOrder>>,
  TError,
  { data: BodyType<CreateOrderRequest> },
  TContext
> => {
  return useMutation(getCreateOrderMutationOptions(options));
};

/**
 * When enabled, the expiry sweep auto-creates a renewal order for the same plan at period end (payment stays a manual bank transfer) instead of silently expiring the plan.

 * @summary Toggle auto-renew on the account's active subscription
 */
export const getSetSubscriptionAutoRenewUrl = () => {
  return `/api/purchasing/subscription/auto-renew`;
};

export const setSubscriptionAutoRenew = async (
  setAutoRenewRequest: SetAutoRenewRequest,
  options?: RequestInit,
): Promise<AutoRenewResponse> => {
  return customFetch<AutoRenewResponse>(getSetSubscriptionAutoRenewUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(setAutoRenewRequest),
  });
};

export const getSetSubscriptionAutoRenewMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setSubscriptionAutoRenew>>,
    TError,
    { data: BodyType<SetAutoRenewRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setSubscriptionAutoRenew>>,
  TError,
  { data: BodyType<SetAutoRenewRequest> },
  TContext
> => {
  const mutationKey = ["setSubscriptionAutoRenew"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setSubscriptionAutoRenew>>,
    { data: BodyType<SetAutoRenewRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return setSubscriptionAutoRenew(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetSubscriptionAutoRenewMutationResult = NonNullable<
  Awaited<ReturnType<typeof setSubscriptionAutoRenew>>
>;
export type SetSubscriptionAutoRenewMutationBody =
  BodyType<SetAutoRenewRequest>;
export type SetSubscriptionAutoRenewMutationError = ErrorType<void>;

/**
 * @summary Toggle auto-renew on the account's active subscription
 */
export const useSetSubscriptionAutoRenew = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setSubscriptionAutoRenew>>,
    TError,
    { data: BodyType<SetAutoRenewRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setSubscriptionAutoRenew>>,
  TError,
  { data: BodyType<SetAutoRenewRequest> },
  TContext
> => {
  return useMutation(getSetSubscriptionAutoRenewMutationOptions(options));
};

/**
 * Creates a pending order for the account's most recent subscription plan through the normal purchase pipeline and returns it with the QR checkout info. If a still-payable subscription order already exists it is reused instead of stacking a duplicate.

 * @summary One-click renew — create (or reuse) a pending order for the same plan
 */
export const getRenewSubscriptionUrl = () => {
  return `/api/purchasing/subscription/renew`;
};

export const renewSubscription = async (
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getRenewSubscriptionUrl(), {
    ...options,
    method: "POST",
  });
};

export const getRenewSubscriptionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renewSubscription>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof renewSubscription>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["renewSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof renewSubscription>>,
    void
  > = () => {
    return renewSubscription(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RenewSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof renewSubscription>>
>;

export type RenewSubscriptionMutationError = ErrorType<void>;

/**
 * @summary One-click renew — create (or reuse) a pending order for the same plan
 */
export const useRenewSubscription = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof renewSubscription>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof renewSubscription>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRenewSubscriptionMutationOptions(options));
};

/**
 * @summary Get a single order (includes QR / bank-transfer info while pending)
 */
export const getGetOrderUrl = (id: string) => {
  return `/api/purchasing/orders/${id}`;
};

export const getOrder = async (
  id: string,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getGetOrderUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetOrderQueryKey = (id: string) => {
  return [`/api/purchasing/orders/${id}`] as const;
};

export const getGetOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrder>>> = ({
    signal,
  }) => getOrder(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getOrder>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrder>>
>;
export type GetOrderQueryError = ErrorType<void>;

/**
 * @summary Get a single order (includes QR / bank-transfer info while pending)
 */

export function useGetOrder<
  TData = Awaited<ReturnType<typeof getOrder>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getOrder>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetOrderQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Download the PDF invoice for a paid order
 */
export const getDownloadOrderInvoiceUrl = (
  id: string,
  params?: DownloadOrderInvoiceParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/purchasing/orders/${id}/invoice?${stringifiedParams}`
    : `/api/purchasing/orders/${id}/invoice`;
};

export const downloadOrderInvoice = async (
  id: string,
  params?: DownloadOrderInvoiceParams,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadOrderInvoiceUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getDownloadOrderInvoiceQueryKey = (
  id: string,
  params?: DownloadOrderInvoiceParams,
) => {
  return [
    `/api/purchasing/orders/${id}/invoice`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDownloadOrderInvoiceQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadOrderInvoice>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: DownloadOrderInvoiceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadOrderInvoice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadOrderInvoiceQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadOrderInvoice>>
  > = ({ signal }) =>
    downloadOrderInvoice(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadOrderInvoice>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadOrderInvoiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadOrderInvoice>>
>;
export type DownloadOrderInvoiceQueryError = ErrorType<void>;

/**
 * @summary Download the PDF invoice for a paid order
 */

export function useDownloadOrderInvoice<
  TData = Awaited<ReturnType<typeof downloadOrderInvoice>>,
  TError = ErrorType<void>,
>(
  id: string,
  params?: DownloadOrderInvoiceParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadOrderInvoice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadOrderInvoiceQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Cancel a pending order
 */
export const getCancelOrderUrl = (id: string) => {
  return `/api/purchasing/orders/${id}/cancel`;
};

export const cancelOrder = async (
  id: string,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getCancelOrderUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCancelOrderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelOrder>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelOrder>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelOrder>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelOrder(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelOrder>>
>;

export type CancelOrderMutationError = ErrorType<void>;

/**
 * @summary Cancel a pending order
 */
export const useCancelOrder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelOrder>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelOrder>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelOrderMutationOptions(options));
};

/**
 * @summary Internal manual confirm of an order (employee only)
 */
export const getConfirmOrderManuallyUrl = (id: string) => {
  return `/api/purchasing/orders/${id}/confirm`;
};

export const confirmOrderManually = async (
  id: string,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getConfirmOrderManuallyUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getConfirmOrderManuallyMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmOrderManually>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmOrderManually>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["confirmOrderManually"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmOrderManually>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return confirmOrderManually(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmOrderManuallyMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmOrderManually>>
>;

export type ConfirmOrderManuallyMutationError = ErrorType<void>;

/**
 * @summary Internal manual confirm of an order (employee only)
 */
export const useConfirmOrderManually = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmOrderManually>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmOrderManually>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getConfirmOrderManuallyMutationOptions(options));
};

/**
 * @summary Get the account's saved VAT invoice details
 */
export const getGetVatProfileUrl = () => {
  return `/api/purchasing/vat-profile`;
};

export const getVatProfile = async (
  options?: RequestInit,
): Promise<VatProfileResponse> => {
  return customFetch<VatProfileResponse>(getGetVatProfileUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetVatProfileQueryKey = () => {
  return [`/api/purchasing/vat-profile`] as const;
};

export const getGetVatProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getVatProfile>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVatProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVatProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVatProfile>>> = ({
    signal,
  }) => getVatProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVatProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetVatProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVatProfile>>
>;
export type GetVatProfileQueryError = ErrorType<void>;

/**
 * @summary Get the account's saved VAT invoice details
 */

export function useGetVatProfile<
  TData = Awaited<ReturnType<typeof getVatProfile>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getVatProfile>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetVatProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Save/replace the account's VAT invoice details
 */
export const getSaveVatProfileUrl = () => {
  return `/api/purchasing/vat-profile`;
};

export const saveVatProfile = async (
  vatInvoiceDetails: VatInvoiceDetails,
  options?: RequestInit,
): Promise<VatProfileResponse> => {
  return customFetch<VatProfileResponse>(getSaveVatProfileUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vatInvoiceDetails),
  });
};

export const getSaveVatProfileMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveVatProfile>>,
    TError,
    { data: BodyType<VatInvoiceDetails> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveVatProfile>>,
  TError,
  { data: BodyType<VatInvoiceDetails> },
  TContext
> => {
  const mutationKey = ["saveVatProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveVatProfile>>,
    { data: BodyType<VatInvoiceDetails> }
  > = (props) => {
    const { data } = props ?? {};

    return saveVatProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveVatProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveVatProfile>>
>;
export type SaveVatProfileMutationBody = BodyType<VatInvoiceDetails>;
export type SaveVatProfileMutationError = ErrorType<void>;

/**
 * @summary Save/replace the account's VAT invoice details
 */
export const useSaveVatProfile = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveVatProfile>>,
    TError,
    { data: BodyType<VatInvoiceDetails> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveVatProfile>>,
  TError,
  { data: BodyType<VatInvoiceDetails> },
  TContext
> => {
  return useMutation(getSaveVatProfileMutationOptions(options));
};

/**
 * Snapshots the submitted company details onto the order (status none → requested) and saves them as the account's VAT profile. Staff issue the invoice manually from the admin back-office.

 * @summary Request a VAT e-invoice for a paid order
 */
export const getRequestVatInvoiceUrl = (id: string) => {
  return `/api/purchasing/orders/${id}/request-vat-invoice`;
};

export const requestVatInvoice = async (
  id: string,
  vatInvoiceDetails: VatInvoiceDetails,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getRequestVatInvoiceUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vatInvoiceDetails),
  });
};

export const getRequestVatInvoiceMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestVatInvoice>>,
    TError,
    { id: string; data: BodyType<VatInvoiceDetails> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestVatInvoice>>,
  TError,
  { id: string; data: BodyType<VatInvoiceDetails> },
  TContext
> => {
  const mutationKey = ["requestVatInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestVatInvoice>>,
    { id: string; data: BodyType<VatInvoiceDetails> }
  > = (props) => {
    const { id, data } = props ?? {};

    return requestVatInvoice(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestVatInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestVatInvoice>>
>;
export type RequestVatInvoiceMutationBody = BodyType<VatInvoiceDetails>;
export type RequestVatInvoiceMutationError = ErrorType<void>;

/**
 * @summary Request a VAT e-invoice for a paid order
 */
export const useRequestVatInvoice = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestVatInvoice>>,
    TError,
    { id: string; data: BodyType<VatInvoiceDetails> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestVatInvoice>>,
  TError,
  { id: string; data: BodyType<VatInvoiceDetails> },
  TContext
> => {
  return useMutation(getRequestVatInvoiceMutationOptions(options));
};

/**
 * Replaces the company details snapshotted on the order while the VAT invoice request is still pending (status "requested"). Rejected once the invoice has been issued. Also refreshes the account's saved VAT profile.

 * @summary Edit the details of a pending VAT invoice request
 */
export const getUpdateVatInvoiceRequestUrl = (id: string) => {
  return `/api/purchasing/orders/${id}/vat-invoice-request`;
};

export const updateVatInvoiceRequest = async (
  id: string,
  vatInvoiceDetails: VatInvoiceDetails,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getUpdateVatInvoiceRequestUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vatInvoiceDetails),
  });
};

export const getUpdateVatInvoiceRequestMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVatInvoiceRequest>>,
    TError,
    { id: string; data: BodyType<VatInvoiceDetails> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVatInvoiceRequest>>,
  TError,
  { id: string; data: BodyType<VatInvoiceDetails> },
  TContext
> => {
  const mutationKey = ["updateVatInvoiceRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVatInvoiceRequest>>,
    { id: string; data: BodyType<VatInvoiceDetails> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateVatInvoiceRequest(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVatInvoiceRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVatInvoiceRequest>>
>;
export type UpdateVatInvoiceRequestMutationBody = BodyType<VatInvoiceDetails>;
export type UpdateVatInvoiceRequestMutationError = ErrorType<void>;

/**
 * @summary Edit the details of a pending VAT invoice request
 */
export const useUpdateVatInvoiceRequest = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVatInvoiceRequest>>,
    TError,
    { id: string; data: BodyType<VatInvoiceDetails> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateVatInvoiceRequest>>,
  TError,
  { id: string; data: BodyType<VatInvoiceDetails> },
  TContext
> => {
  return useMutation(getUpdateVatInvoiceRequestMutationOptions(options));
};

/**
 * Cancels a pending VAT invoice request (status "requested" back to "none") and clears the snapshotted details, so the buyer can request again later. Rejected once the invoice has been issued.

 * @summary Withdraw a pending VAT invoice request
 */
export const getCancelVatInvoiceRequestUrl = (id: string) => {
  return `/api/purchasing/orders/${id}/vat-invoice-request`;
};

export const cancelVatInvoiceRequest = async (
  id: string,
  options?: RequestInit,
): Promise<Order> => {
  return customFetch<Order>(getCancelVatInvoiceRequestUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getCancelVatInvoiceRequestMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelVatInvoiceRequest>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelVatInvoiceRequest>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelVatInvoiceRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelVatInvoiceRequest>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelVatInvoiceRequest(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelVatInvoiceRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelVatInvoiceRequest>>
>;

export type CancelVatInvoiceRequestMutationError = ErrorType<void>;

/**
 * @summary Withdraw a pending VAT invoice request
 */
export const useCancelVatInvoiceRequest = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelVatInvoiceRequest>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelVatInvoiceRequest>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelVatInvoiceRequestMutationOptions(options));
};

/**
 * @summary Download the issued VAT invoice file for an order
 */
export const getDownloadVatInvoiceFileUrl = (id: string) => {
  return `/api/purchasing/orders/${id}/vat-invoice-file`;
};

export const downloadVatInvoiceFile = async (
  id: string,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(getDownloadVatInvoiceFileUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadVatInvoiceFileQueryKey = (id: string) => {
  return [`/api/purchasing/orders/${id}/vat-invoice-file`] as const;
};

export const getDownloadVatInvoiceFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadVatInvoiceFile>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadVatInvoiceFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadVatInvoiceFileQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadVatInvoiceFile>>
  > = ({ signal }) => downloadVatInvoiceFile(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadVatInvoiceFile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadVatInvoiceFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadVatInvoiceFile>>
>;
export type DownloadVatInvoiceFileQueryError = ErrorType<void>;

/**
 * @summary Download the issued VAT invoice file for an order
 */

export function useDownloadVatInvoiceFile<
  TData = Awaited<ReturnType<typeof downloadVatInvoiceFile>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadVatInvoiceFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadVatInvoiceFileQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Called by a bank-transfer reconciliation service / payment gateway when a transfer lands. Authenticated by a shared-secret header inside the adapter, not a user session. Reconciles the transfer to a pending order by transfer reference and provisions it through the single confirmOrder function.

 * @summary Bank-transfer reconciliation callback (server-to-server, CSRF-exempt)
 */
export const getPaymentWebhookUrl = () => {
  return `/api/webhooks/payments`;
};

export const paymentWebhook = async (
  paymentWebhookRequest: PaymentWebhookRequest,
  options?: RequestInit,
): Promise<PaymentWebhookResult> => {
  return customFetch<PaymentWebhookResult>(getPaymentWebhookUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(paymentWebhookRequest),
  });
};

export const getPaymentWebhookMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentWebhook>>,
    TError,
    { data: BodyType<PaymentWebhookRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof paymentWebhook>>,
  TError,
  { data: BodyType<PaymentWebhookRequest> },
  TContext
> => {
  const mutationKey = ["paymentWebhook"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof paymentWebhook>>,
    { data: BodyType<PaymentWebhookRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return paymentWebhook(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PaymentWebhookMutationResult = NonNullable<
  Awaited<ReturnType<typeof paymentWebhook>>
>;
export type PaymentWebhookMutationBody = BodyType<PaymentWebhookRequest>;
export type PaymentWebhookMutationError = ErrorType<void>;

/**
 * @summary Bank-transfer reconciliation callback (server-to-server, CSRF-exempt)
 */
export const usePaymentWebhook = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof paymentWebhook>>,
    TError,
    { data: BodyType<PaymentWebhookRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof paymentWebhook>>,
  TError,
  { data: BodyType<PaymentWebhookRequest> },
  TContext
> => {
  return useMutation(getPaymentWebhookMutationOptions(options));
};

/**
 * Returns server + fal.ai connectivity status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Request a presigned upload URL for the source design
 */
export const getRequestUploadUrlUrl = () => {
  return `/api/storage/uploads/request-url`;
};

export const requestUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<UploadUrlResponseData> => {
  return customFetch<UploadUrlResponseData>(getRequestUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getRequestUploadUrlMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  const mutationKey = ["requestUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    { data: BodyType<UploadUrlRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return requestUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestUploadUrl>>
>;
export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>;
export type RequestUploadUrlMutationError = ErrorType<unknown>;

/**
 * @summary Request a presigned upload URL for the source design
 */
export const useRequestUploadUrl = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestUploadUrl>>,
    TError,
    { data: BodyType<UploadUrlRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestUploadUrl>>,
  TError,
  { data: BodyType<UploadUrlRequest> },
  TContext
> => {
  return useMutation(getRequestUploadUrlMutationOptions(options));
};

/**
 * @summary Aggregate counts for the asset library
 */
export const getGetDashboardSummaryUrl = () => {
  return `/api/dashboard/summary`;
};

export const getDashboardSummary = async (
  options?: RequestInit,
): Promise<DashboardSummary> => {
  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetDashboardSummaryQueryKey = () => {
  return [`/api/dashboard/summary`] as const;
};

export const getGetDashboardSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardSummary>>
  > = ({ signal }) => getDashboardSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDashboardSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDashboardSummary>>
>;
export type GetDashboardSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Aggregate counts for the asset library
 */

export function useGetDashboardSummary<
  TData = Awaited<ReturnType<typeof getDashboardSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDashboardSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Recent jobs and asset events
 */
export const getGetRecentActivityUrl = () => {
  return `/api/dashboard/recent-activity`;
};

export const getRecentActivity = async (
  options?: RequestInit,
): Promise<ActivityItem[]> => {
  return customFetch<ActivityItem[]>(getGetRecentActivityUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetRecentActivityQueryKey = () => {
  return [`/api/dashboard/recent-activity`] as const;
};

export const getGetRecentActivityQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRecentActivity>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecentActivityQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRecentActivity>>
  > = ({ signal }) => getRecentActivity({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecentActivity>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecentActivityQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecentActivity>>
>;
export type GetRecentActivityQueryError = ErrorType<unknown>;

/**
 * @summary Recent jobs and asset events
 */

export function useGetRecentActivity<
  TData = Awaited<ReturnType<typeof getRecentActivity>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getRecentActivity>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecentActivityQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List the signed-in user's assets
 */
export const getListAssetsUrl = (params?: ListAssetsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/assets?${stringifiedParams}`
    : `/api/assets`;
};

export const listAssets = async (
  params?: ListAssetsParams,
  options?: RequestInit,
): Promise<Asset[]> => {
  return customFetch<Asset[]>(getListAssetsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListAssetsQueryKey = (params?: ListAssetsParams) => {
  return [`/api/assets`, ...(params ? [params] : [])] as const;
};

export const getListAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAssetsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAssetsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssets>>> = ({
    signal,
  }) => listAssets(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAssets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAssets>>
>;
export type ListAssetsQueryError = ErrorType<unknown>;

/**
 * @summary List the signed-in user's assets
 */

export function useListAssets<
  TData = Awaited<ReturnType<typeof listAssets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListAssetsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAssetsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Register an uploaded source design
 */
export const getCreateAssetUrl = () => {
  return `/api/assets`;
};

export const createAsset = async (
  newAsset: NewAsset,
  options?: RequestInit,
): Promise<Asset> => {
  return customFetch<Asset>(getCreateAssetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(newAsset),
  });
};

export const getCreateAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAsset>>,
    TError,
    { data: BodyType<NewAsset> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAsset>>,
  TError,
  { data: BodyType<NewAsset> },
  TContext
> => {
  const mutationKey = ["createAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAsset>>,
    { data: BodyType<NewAsset> }
  > = (props) => {
    const { data } = props ?? {};

    return createAsset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAsset>>
>;
export type CreateAssetMutationBody = BodyType<NewAsset>;
export type CreateAssetMutationError = ErrorType<unknown>;

/**
 * @summary Register an uploaded source design
 */
export const useCreateAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAsset>>,
    TError,
    { data: BodyType<NewAsset> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createAsset>>,
  TError,
  { data: BodyType<NewAsset> },
  TContext
> => {
  return useMutation(getCreateAssetMutationOptions(options));
};

/**
 * @summary Aggregate bbox-crop supplementation rates across the user's assets
 */
export const getGetBboxCropTelemetryUrl = () => {
  return `/api/assets/telemetry/bbox-crop`;
};

export const getBboxCropTelemetry = async (
  options?: RequestInit,
): Promise<BboxCropTelemetry> => {
  return customFetch<BboxCropTelemetry>(getGetBboxCropTelemetryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBboxCropTelemetryQueryKey = () => {
  return [`/api/assets/telemetry/bbox-crop`] as const;
};

export const getGetBboxCropTelemetryQueryOptions = <
  TData = Awaited<ReturnType<typeof getBboxCropTelemetry>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBboxCropTelemetry>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBboxCropTelemetryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBboxCropTelemetry>>
  > = ({ signal }) => getBboxCropTelemetry({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBboxCropTelemetry>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBboxCropTelemetryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBboxCropTelemetry>>
>;
export type GetBboxCropTelemetryQueryError = ErrorType<unknown>;

/**
 * @summary Aggregate bbox-crop supplementation rates across the user's assets
 */

export function useGetBboxCropTelemetry<
  TData = Awaited<ReturnType<typeof getBboxCropTelemetry>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBboxCropTelemetry>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBboxCropTelemetryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Returns periodic snapshots (typically one per day) of the same aggregate metrics surfaced by `/assets/telemetry/bbox-crop`. Used by the dashboard's trend chart so the team can spot whether the supplementation and survival rates are improving over time.

 * @summary Time-series of historical bbox-crop telemetry snapshots
 */
export const getGetBboxCropTelemetryHistoryUrl = (
  params?: GetBboxCropTelemetryHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/assets/telemetry/bbox-crop/history?${stringifiedParams}`
    : `/api/assets/telemetry/bbox-crop/history`;
};

export const getBboxCropTelemetryHistory = async (
  params?: GetBboxCropTelemetryHistoryParams,
  options?: RequestInit,
): Promise<BboxCropTelemetryHistory> => {
  return customFetch<BboxCropTelemetryHistory>(
    getGetBboxCropTelemetryHistoryUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBboxCropTelemetryHistoryQueryKey = (
  params?: GetBboxCropTelemetryHistoryParams,
) => {
  return [
    `/api/assets/telemetry/bbox-crop/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBboxCropTelemetryHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getBboxCropTelemetryHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBboxCropTelemetryHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBboxCropTelemetryHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBboxCropTelemetryHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBboxCropTelemetryHistory>>
  > = ({ signal }) =>
    getBboxCropTelemetryHistory(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBboxCropTelemetryHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBboxCropTelemetryHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBboxCropTelemetryHistory>>
>;
export type GetBboxCropTelemetryHistoryQueryError = ErrorType<unknown>;

/**
 * @summary Time-series of historical bbox-crop telemetry snapshots
 */

export function useGetBboxCropTelemetryHistory<
  TData = Awaited<ReturnType<typeof getBboxCropTelemetryHistory>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBboxCropTelemetryHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBboxCropTelemetryHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBboxCropTelemetryHistoryQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetAssetUrl = (id: string) => {
  return `/api/assets/${id}`;
};

export const getAsset = async (
  id: string,
  options?: RequestInit,
): Promise<AssetDetail> => {
  return customFetch<AssetDetail>(getGetAssetUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetAssetQueryKey = (id: string) => {
  return [`/api/assets/${id}`] as const;
};

export const getGetAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAsset>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAssetQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAsset>>> = ({
    signal,
  }) => getAsset(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAsset>>
>;
export type GetAssetQueryError = ErrorType<unknown>;

export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAsset>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAssetQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getDeleteAssetUrl = (id: string) => {
  return `/api/assets/${id}`;
};

export const deleteAsset = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteAssetUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAsset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAsset>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteAsset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAsset>>
>;

export type DeleteAssetMutationError = ErrorType<unknown>;

export const useDeleteAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAsset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteAssetMutationOptions(options));
};

/**
 * @summary Kick off fal.ai layer decomposition
 */
export const getAnalyzeAssetUrl = (id: string) => {
  return `/api/assets/${id}/analyze`;
};

export const analyzeAsset = async (
  id: string,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getAnalyzeAssetUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAnalyzeAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeAsset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeAsset>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["analyzeAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeAsset>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return analyzeAsset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeAsset>>
>;

export type AnalyzeAssetMutationError = ErrorType<unknown>;

/**
 * @summary Kick off fal.ai layer decomposition
 */
export const useAnalyzeAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeAsset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeAsset>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAnalyzeAssetMutationOptions(options));
};

/**
 * Called only by backend jobs.
 * @summary Re-run fal extraction with an "extract more" prompt to surface missed layers
 */
export const getExtractMoreLayersUrl = (id: string) => {
  return `/api/assets/${id}/extract-more`;
};

export const extractMoreLayers = async (
  id: string,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getExtractMoreLayersUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getExtractMoreLayersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractMoreLayers>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof extractMoreLayers>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["extractMoreLayers"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof extractMoreLayers>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return extractMoreLayers(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExtractMoreLayersMutationResult = NonNullable<
  Awaited<ReturnType<typeof extractMoreLayers>>
>;

export type ExtractMoreLayersMutationError = ErrorType<unknown>;

/**
 * @summary Re-run fal extraction with an "extract more" prompt to surface missed layers
 */
export const useExtractMoreLayers = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof extractMoreLayers>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof extractMoreLayers>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getExtractMoreLayersMutationOptions(options));
};

export const getListLayersUrl = (id: string) => {
  return `/api/assets/${id}/layers`;
};

export const listLayers = async (
  id: string,
  options?: RequestInit,
): Promise<Layer[]> => {
  return customFetch<Layer[]>(getListLayersUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListLayersQueryKey = (id: string) => {
  return [`/api/assets/${id}/layers`] as const;
};

export const getListLayersQueryOptions = <
  TData = Awaited<ReturnType<typeof listLayers>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLayers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListLayersQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listLayers>>> = ({
    signal,
  }) => listLayers(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listLayers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListLayersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listLayers>>
>;
export type ListLayersQueryError = ErrorType<unknown>;

export function useListLayers<
  TData = Awaited<ReturnType<typeof listLayers>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listLayers>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListLayersQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Called only by backend jobs.
 * @summary Classify a layer and (optionally) override its bbox
 */
export const getUpdateLayerUrl = (id: string, layerId: string) => {
  return `/api/assets/${id}/layers/${layerId}`;
};

export const updateLayer = async (
  id: string,
  layerId: string,
  layerUpdate: LayerUpdate,
  options?: RequestInit,
): Promise<Layer> => {
  return customFetch<Layer>(getUpdateLayerUrl(id, layerId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(layerUpdate),
  });
};

export const getUpdateLayerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLayer>>,
    TError,
    { id: string; layerId: string; data: BodyType<LayerUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLayer>>,
  TError,
  { id: string; layerId: string; data: BodyType<LayerUpdate> },
  TContext
> => {
  const mutationKey = ["updateLayer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLayer>>,
    { id: string; layerId: string; data: BodyType<LayerUpdate> }
  > = (props) => {
    const { id, layerId, data } = props ?? {};

    return updateLayer(id, layerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLayerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLayer>>
>;
export type UpdateLayerMutationBody = BodyType<LayerUpdate>;
export type UpdateLayerMutationError = ErrorType<unknown>;

/**
 * @summary Classify a layer and (optionally) override its bbox
 */
export const useUpdateLayer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLayer>>,
    TError,
    { id: string; layerId: string; data: BodyType<LayerUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLayer>>,
  TError,
  { id: string; layerId: string; data: BodyType<LayerUpdate> },
  TContext
> => {
  return useMutation(getUpdateLayerMutationOptions(options));
};

/**
 * Called only by backend jobs.
 * @summary Delete an extracted layer (and its object-storage PNG); reindexes the remaining layers
 */
export const getDeleteLayerUrl = (id: string, layerId: string) => {
  return `/api/assets/${id}/layers/${layerId}`;
};

export const deleteLayer = async (
  id: string,
  layerId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteLayerUrl(id, layerId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteLayerMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLayer>>,
    TError,
    { id: string; layerId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteLayer>>,
  TError,
  { id: string; layerId: string },
  TContext
> => {
  const mutationKey = ["deleteLayer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteLayer>>,
    { id: string; layerId: string }
  > = (props) => {
    const { id, layerId } = props ?? {};

    return deleteLayer(id, layerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteLayerMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteLayer>>
>;

export type DeleteLayerMutationError = ErrorType<void>;

/**
 * @summary Delete an extracted layer (and its object-storage PNG); reindexes the remaining layers
 */
export const useDeleteLayer = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteLayer>>,
    TError,
    { id: string; layerId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteLayer>>,
  TError,
  { id: string; layerId: string },
  TContext
> => {
  return useMutation(getDeleteLayerMutationOptions(options));
};

/**
 * @summary Mark layer classification as confirmed (asset moves to ready_to_generate)
 */
export const getConfirmClassificationUrl = (id: string) => {
  return `/api/assets/${id}/classification`;
};

export const confirmClassification = async (
  id: string,
  options?: RequestInit,
): Promise<Asset> => {
  return customFetch<Asset>(getConfirmClassificationUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getConfirmClassificationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmClassification>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmClassification>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["confirmClassification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmClassification>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return confirmClassification(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmClassificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmClassification>>
>;

export type ConfirmClassificationMutationError = ErrorType<unknown>;

/**
 * @summary Mark layer classification as confirmed (asset moves to ready_to_generate)
 */
export const useConfirmClassification = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmClassification>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmClassification>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getConfirmClassificationMutationOptions(options));
};

/**
 * @summary Re-run Gemini classifier on existing layers
 */
export const getReclassifyAssetUrl = (id: string) => {
  return `/api/assets/${id}/reclassify`;
};

export const reclassifyAsset = async (
  id: string,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getReclassifyAssetUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getReclassifyAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reclassifyAsset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reclassifyAsset>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["reclassifyAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reclassifyAsset>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return reclassifyAsset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReclassifyAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof reclassifyAsset>>
>;

export type ReclassifyAssetMutationError = ErrorType<unknown>;

/**
 * @summary Re-run Gemini classifier on existing layers
 */
export const useReclassifyAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reclassifyAsset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reclassifyAsset>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getReclassifyAssetMutationOptions(options));
};

/**
 * Clears `designAnalysis` and `tierAdapted` from the asset's analysis cache, invalidates any pre-generate verification report, then enqueues a fresh analyze job. If a queued/running analyze/classify/extract_more job already exists for this asset, returns that job instead of enqueueing a duplicate (200).
 * @summary Drop cached design analysis + tier-adapted layouts and re-run analyze
 */
export const getReanalyzeAssetUrl = (id: string) => {
  return `/api/assets/${id}/reanalyze`;
};

export const reanalyzeAsset = async (
  id: string,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getReanalyzeAssetUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getReanalyzeAssetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reanalyzeAsset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reanalyzeAsset>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["reanalyzeAsset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reanalyzeAsset>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return reanalyzeAsset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReanalyzeAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof reanalyzeAsset>>
>;

export type ReanalyzeAssetMutationError = ErrorType<unknown>;

/**
 * @summary Drop cached design analysis + tier-adapted layouts and re-run analyze
 */
export const useReanalyzeAsset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reanalyzeAsset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reanalyzeAsset>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getReanalyzeAssetMutationOptions(options));
};

/**
 * Patches `designAnalysis.items[sourceItemIndex].bbox` in place using a fresh Gemini call scoped to a single text/wordmark element. Clears `analysisCache.tierAdapted` so the next overlay or generate pass picks up the new bbox. Returns 400 if the asset has no design analysis or the item is not a text/wordmark; 404 if the index is out of range; 502 if Gemini cannot relocate the element.
 * @summary Re-run a focused Gemini call to refresh one design item's bbox without regenerating the image
 */
export const getReanalyzeBboxUrl = (id: string) => {
  return `/api/assets/${id}/reanalyze-bbox`;
};

export const reanalyzeBbox = async (
  id: string,
  reanalyzeBboxRequest: ReanalyzeBboxRequest,
  options?: RequestInit,
): Promise<ReanalyzeBboxResponse> => {
  return customFetch<ReanalyzeBboxResponse>(getReanalyzeBboxUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(reanalyzeBboxRequest),
  });
};

export const getReanalyzeBboxMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reanalyzeBbox>>,
    TError,
    { id: string; data: BodyType<ReanalyzeBboxRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reanalyzeBbox>>,
  TError,
  { id: string; data: BodyType<ReanalyzeBboxRequest> },
  TContext
> => {
  const mutationKey = ["reanalyzeBbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reanalyzeBbox>>,
    { id: string; data: BodyType<ReanalyzeBboxRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return reanalyzeBbox(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReanalyzeBboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof reanalyzeBbox>>
>;
export type ReanalyzeBboxMutationBody = BodyType<ReanalyzeBboxRequest>;
export type ReanalyzeBboxMutationError = ErrorType<void>;

/**
 * @summary Re-run a focused Gemini call to refresh one design item's bbox without regenerating the image
 */
export const useReanalyzeBbox = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reanalyzeBbox>>,
    TError,
    { id: string; data: BodyType<ReanalyzeBboxRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof reanalyzeBbox>>,
  TError,
  { id: string; data: BodyType<ReanalyzeBboxRequest> },
  TContext
> => {
  return useMutation(getReanalyzeBboxMutationOptions(options));
};

/**
 * Called only by backend jobs.
 * @summary Override the classifier output for a single layer
 */
export const getUpdateLayerClassificationUrl = (
  id: string,
  layerId: string,
) => {
  return `/api/assets/${id}/layers/${layerId}/classification`;
};

export const updateLayerClassification = async (
  id: string,
  layerId: string,
  layerClassificationUpdate: LayerClassificationUpdate,
  options?: RequestInit,
): Promise<Layer> => {
  return customFetch<Layer>(getUpdateLayerClassificationUrl(id, layerId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(layerClassificationUpdate),
  });
};

export const getUpdateLayerClassificationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLayerClassification>>,
    TError,
    { id: string; layerId: string; data: BodyType<LayerClassificationUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateLayerClassification>>,
  TError,
  { id: string; layerId: string; data: BodyType<LayerClassificationUpdate> },
  TContext
> => {
  const mutationKey = ["updateLayerClassification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateLayerClassification>>,
    { id: string; layerId: string; data: BodyType<LayerClassificationUpdate> }
  > = (props) => {
    const { id, layerId, data } = props ?? {};

    return updateLayerClassification(id, layerId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateLayerClassificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateLayerClassification>>
>;
export type UpdateLayerClassificationMutationBody =
  BodyType<LayerClassificationUpdate>;
export type UpdateLayerClassificationMutationError = ErrorType<unknown>;

/**
 * @summary Override the classifier output for a single layer
 */
export const useUpdateLayerClassification = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateLayerClassification>>,
    TError,
    { id: string; layerId: string; data: BodyType<LayerClassificationUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateLayerClassification>>,
  TError,
  { id: string; layerId: string; data: BodyType<LayerClassificationUpdate> },
  TContext
> => {
  return useMutation(getUpdateLayerClassificationMutationOptions(options));
};

/**
 * Restores type=suggestedType and re-applies the auto-classifier defaults for preserveOriginal/zIndex. 409 if the layer was not manually edited.
 * @summary Revert a manual layer classification back to the AI's original suggestion
 */
export const getRevertLayerClassificationUrl = (
  id: string,
  layerId: string,
) => {
  return `/api/assets/${id}/layers/${layerId}/classification/revert`;
};

export const revertLayerClassification = async (
  id: string,
  layerId: string,
  options?: RequestInit,
): Promise<Layer> => {
  return customFetch<Layer>(getRevertLayerClassificationUrl(id, layerId), {
    ...options,
    method: "POST",
  });
};

export const getRevertLayerClassificationMutationOptions = <
  TError = ErrorType<RevertLayerClassification409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertLayerClassification>>,
    TError,
    { id: string; layerId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertLayerClassification>>,
  TError,
  { id: string; layerId: string },
  TContext
> => {
  const mutationKey = ["revertLayerClassification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertLayerClassification>>,
    { id: string; layerId: string }
  > = (props) => {
    const { id, layerId } = props ?? {};

    return revertLayerClassification(id, layerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertLayerClassificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertLayerClassification>>
>;

export type RevertLayerClassificationMutationError =
  ErrorType<RevertLayerClassification409>;

/**
 * @summary Revert a manual layer classification back to the AI's original suggestion
 */
export const useRevertLayerClassification = <
  TError = ErrorType<RevertLayerClassification409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertLayerClassification>>,
    TError,
    { id: string; layerId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revertLayerClassification>>,
  TError,
  { id: string; layerId: string },
  TContext
> => {
  return useMutation(getRevertLayerClassificationMutationOptions(options));
};

/**
 * Called only by backend jobs.
 * @summary Get classifier results plus low-confidence count for an asset
 */
export const getGetClassificationSummaryUrl = (id: string) => {
  return `/api/assets/${id}/classification-summary`;
};

export const getClassificationSummary = async (
  id: string,
  options?: RequestInit,
): Promise<ClassificationSummary> => {
  return customFetch<ClassificationSummary>(
    getGetClassificationSummaryUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetClassificationSummaryQueryKey = (id: string) => {
  return [`/api/assets/${id}/classification-summary`] as const;
};

export const getGetClassificationSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getClassificationSummary>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClassificationSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClassificationSummaryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getClassificationSummary>>
  > = ({ signal }) =>
    getClassificationSummary(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getClassificationSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetClassificationSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClassificationSummary>>
>;
export type GetClassificationSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Get classifier results plus low-confidence count for an asset
 */

export function useGetClassificationSummary<
  TData = Awaited<ReturnType<typeof getClassificationSummary>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getClassificationSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetClassificationSummaryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Start composite generation for the selected presets
 */
export const getGenerateOutputsUrl = (id: string) => {
  return `/api/assets/${id}/generate`;
};

export const generateOutputs = async (
  id: string,
  generateRequest: GenerateRequest,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getGenerateOutputsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateRequest),
  });
};

export const getGenerateOutputsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOutputs>>,
    TError,
    { id: string; data: BodyType<GenerateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generateOutputs>>,
  TError,
  { id: string; data: BodyType<GenerateRequest> },
  TContext
> => {
  const mutationKey = ["generateOutputs"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generateOutputs>>,
    { id: string; data: BodyType<GenerateRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return generateOutputs(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateOutputsMutationResult = NonNullable<
  Awaited<ReturnType<typeof generateOutputs>>
>;
export type GenerateOutputsMutationBody = BodyType<GenerateRequest>;
export type GenerateOutputsMutationError = ErrorType<unknown>;

/**
 * @summary Start composite generation for the selected presets
 */
export const useGenerateOutputs = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generateOutputs>>,
    TError,
    { id: string; data: BodyType<GenerateRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generateOutputs>>,
  TError,
  { id: string; data: BodyType<GenerateRequest> },
  TContext
> => {
  return useMutation(getGenerateOutputsMutationOptions(options));
};

/**
 * Returns the LayoutHint[] the per-format arrange editor should
seed itself with for the given preset. The bboxes are derived
from the asset's cached `tierAdapted` items (no extra Gemini
call) so what the user sees in the editor matches what the
generator will follow if they accept the proposal as-is.

Returns 409 if the asset has no cached `designAnalysis` (analyze
hasn't completed yet) so the SPA can show a clear loading state
rather than an empty proposal that looks like a bug.

 * @summary Suggest a per-preset LayoutHint[] derived from the cached design analysis
 */
export const getProposeLayoutUrl = (id: string) => {
  return `/api/assets/${id}/propose-layout`;
};

export const proposeLayout = async (
  id: string,
  proposeLayoutRequest: ProposeLayoutRequest,
  options?: RequestInit,
): Promise<ProposeLayoutResponse> => {
  return customFetch<ProposeLayoutResponse>(getProposeLayoutUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(proposeLayoutRequest),
  });
};

export const getProposeLayoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proposeLayout>>,
    TError,
    { id: string; data: BodyType<ProposeLayoutRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof proposeLayout>>,
  TError,
  { id: string; data: BodyType<ProposeLayoutRequest> },
  TContext
> => {
  const mutationKey = ["proposeLayout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof proposeLayout>>,
    { id: string; data: BodyType<ProposeLayoutRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return proposeLayout(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProposeLayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof proposeLayout>>
>;
export type ProposeLayoutMutationBody = BodyType<ProposeLayoutRequest>;
export type ProposeLayoutMutationError = ErrorType<unknown>;

/**
 * @summary Suggest a per-preset LayoutHint[] derived from the cached design analysis
 */
export const useProposeLayout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proposeLayout>>,
    TError,
    { id: string; data: BodyType<ProposeLayoutRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof proposeLayout>>,
  TError,
  { id: string; data: BodyType<ProposeLayoutRequest> },
  TContext
> => {
  return useMutation(getProposeLayoutMutationOptions(options));
};

export const getListOutputsUrl = (id: string) => {
  return `/api/assets/${id}/outputs`;
};

export const listOutputs = async (
  id: string,
  options?: RequestInit,
): Promise<PlatformOutputGroup[]> => {
  return customFetch<PlatformOutputGroup[]>(getListOutputsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListOutputsQueryKey = (id: string) => {
  return [`/api/assets/${id}/outputs`] as const;
};

export const getListOutputsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOutputs>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOutputs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOutputsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listOutputs>>> = ({
    signal,
  }) => listOutputs(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listOutputs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListOutputsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOutputs>>
>;
export type ListOutputsQueryError = ErrorType<unknown>;

export function useListOutputs<
  TData = Awaited<ReturnType<typeof listOutputs>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listOutputs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListOutputsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Re-run the text-overlay engine with user-supplied per-item pixel offsets (no AI re-generation)
 */
export const getAdjustTextOverlayUrl = (id: string) => {
  return `/api/outputs/${id}/text-overlay`;
};

export const adjustTextOverlay = async (
  id: string,
  adjustTextOverlayRequest: AdjustTextOverlayRequest,
  options?: RequestInit,
): Promise<Output> => {
  return customFetch<Output>(getAdjustTextOverlayUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adjustTextOverlayRequest),
  });
};

export const getAdjustTextOverlayMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustTextOverlay>>,
    TError,
    { id: string; data: BodyType<AdjustTextOverlayRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adjustTextOverlay>>,
  TError,
  { id: string; data: BodyType<AdjustTextOverlayRequest> },
  TContext
> => {
  const mutationKey = ["adjustTextOverlay"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adjustTextOverlay>>,
    { id: string; data: BodyType<AdjustTextOverlayRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adjustTextOverlay(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdjustTextOverlayMutationResult = NonNullable<
  Awaited<ReturnType<typeof adjustTextOverlay>>
>;
export type AdjustTextOverlayMutationBody = BodyType<AdjustTextOverlayRequest>;
export type AdjustTextOverlayMutationError = ErrorType<void>;

/**
 * @summary Re-run the text-overlay engine with user-supplied per-item pixel offsets (no AI re-generation)
 */
export const useAdjustTextOverlay = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adjustTextOverlay>>,
    TError,
    { id: string; data: BodyType<AdjustTextOverlayRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adjustTextOverlay>>,
  TError,
  { id: string; data: BodyType<AdjustTextOverlayRequest> },
  TContext
> => {
  return useMutation(getAdjustTextOverlayMutationOptions(options));
};

export const getGetEditStateUrl = (id: string, params: GetEditStateParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/assets/${id}/edit-state?${stringifiedParams}`
    : `/api/assets/${id}/edit-state`;
};

export const getEditState = async (
  id: string,
  params: GetEditStateParams,
  options?: RequestInit,
): Promise<EditState> => {
  return customFetch<EditState>(getGetEditStateUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getGetEditStateQueryKey = (
  id: string,
  params?: GetEditStateParams,
) => {
  return [`/api/assets/${id}/edit-state`, ...(params ? [params] : [])] as const;
};

export const getGetEditStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getEditState>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetEditStateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEditState>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEditStateQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditState>>> = ({
    signal,
  }) => getEditState(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEditState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEditStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEditState>>
>;
export type GetEditStateQueryError = ErrorType<unknown>;

export function useGetEditState<
  TData = Awaited<ReturnType<typeof getEditState>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetEditStateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEditState>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEditStateQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetEditSummaryUrl = (id: string) => {
  return `/api/assets/${id}/edit-summary`;
};

export const getEditSummary = async (
  id: string,
  options?: RequestInit,
): Promise<PresetVersionSummary[]> => {
  return customFetch<PresetVersionSummary[]>(getGetEditSummaryUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetEditSummaryQueryKey = (id: string) => {
  return [`/api/assets/${id}/edit-summary`] as const;
};

export const getGetEditSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getEditSummary>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEditSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEditSummaryQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditSummary>>> = ({
    signal,
  }) => getEditSummary(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEditSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEditSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEditSummary>>
>;
export type GetEditSummaryQueryError = ErrorType<unknown>;

export function useGetEditSummary<
  TData = Awaited<ReturnType<typeof getEditSummary>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEditSummary>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEditSummaryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSaveEditDraftUrl = (id: string) => {
  return `/api/assets/${id}/edit-draft`;
};

export const saveEditDraft = async (
  id: string,
  saveEditDraftRequest: SaveEditDraftRequest,
  options?: RequestInit,
): Promise<EditDraft> => {
  return customFetch<EditDraft>(getSaveEditDraftUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveEditDraftRequest),
  });
};

export const getSaveEditDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveEditDraft>>,
    TError,
    { id: string; data: BodyType<SaveEditDraftRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveEditDraft>>,
  TError,
  { id: string; data: BodyType<SaveEditDraftRequest> },
  TContext
> => {
  const mutationKey = ["saveEditDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveEditDraft>>,
    { id: string; data: BodyType<SaveEditDraftRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return saveEditDraft(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveEditDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveEditDraft>>
>;
export type SaveEditDraftMutationBody = BodyType<SaveEditDraftRequest>;
export type SaveEditDraftMutationError = ErrorType<unknown>;

export const useSaveEditDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveEditDraft>>,
    TError,
    { id: string; data: BodyType<SaveEditDraftRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveEditDraft>>,
  TError,
  { id: string; data: BodyType<SaveEditDraftRequest> },
  TContext
> => {
  return useMutation(getSaveEditDraftMutationOptions(options));
};

export const getRegenerateEditUrl = (id: string) => {
  return `/api/assets/${id}/edit-regenerate`;
};

export const regenerateEdit = async (
  id: string,
  regenerateEditRequest: RegenerateEditRequest,
  options?: RequestInit,
): Promise<RegenerateEditResponse> => {
  return customFetch<RegenerateEditResponse>(getRegenerateEditUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(regenerateEditRequest),
  });
};

export const getRegenerateEditMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateEdit>>,
    TError,
    { id: string; data: BodyType<RegenerateEditRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateEdit>>,
  TError,
  { id: string; data: BodyType<RegenerateEditRequest> },
  TContext
> => {
  const mutationKey = ["regenerateEdit"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateEdit>>,
    { id: string; data: BodyType<RegenerateEditRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return regenerateEdit(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateEditMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateEdit>>
>;
export type RegenerateEditMutationBody = BodyType<RegenerateEditRequest>;
export type RegenerateEditMutationError = ErrorType<unknown>;

export const useRegenerateEdit = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateEdit>>,
    TError,
    { id: string; data: BodyType<RegenerateEditRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof regenerateEdit>>,
  TError,
  { id: string; data: BodyType<RegenerateEditRequest> },
  TContext
> => {
  return useMutation(getRegenerateEditMutationOptions(options));
};

export const getListEditVersionsUrl = (
  id: string,
  params: ListEditVersionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/assets/${id}/edit-versions?${stringifiedParams}`
    : `/api/assets/${id}/edit-versions`;
};

export const listEditVersions = async (
  id: string,
  params: ListEditVersionsParams,
  options?: RequestInit,
): Promise<AssetVersion[]> => {
  return customFetch<AssetVersion[]>(getListEditVersionsUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getListEditVersionsQueryKey = (
  id: string,
  params?: ListEditVersionsParams,
) => {
  return [
    `/api/assets/${id}/edit-versions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListEditVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listEditVersions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: ListEditVersionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEditVersions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListEditVersionsQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listEditVersions>>
  > = ({ signal }) =>
    listEditVersions(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listEditVersions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListEditVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listEditVersions>>
>;
export type ListEditVersionsQueryError = ErrorType<unknown>;

export function useListEditVersions<
  TData = Awaited<ReturnType<typeof listEditVersions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: ListEditVersionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listEditVersions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListEditVersionsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSaveEditVersionUrl = (id: string) => {
  return `/api/assets/${id}/edit-versions`;
};

export const saveEditVersion = async (
  id: string,
  saveAsVersionRequest: SaveAsVersionRequest,
  options?: RequestInit,
): Promise<AssetVersion> => {
  return customFetch<AssetVersion>(getSaveEditVersionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveAsVersionRequest),
  });
};

export const getSaveEditVersionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveEditVersion>>,
    TError,
    { id: string; data: BodyType<SaveAsVersionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveEditVersion>>,
  TError,
  { id: string; data: BodyType<SaveAsVersionRequest> },
  TContext
> => {
  const mutationKey = ["saveEditVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveEditVersion>>,
    { id: string; data: BodyType<SaveAsVersionRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return saveEditVersion(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveEditVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveEditVersion>>
>;
export type SaveEditVersionMutationBody = BodyType<SaveAsVersionRequest>;
export type SaveEditVersionMutationError = ErrorType<unknown>;

export const useSaveEditVersion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveEditVersion>>,
    TError,
    { id: string; data: BodyType<SaveAsVersionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveEditVersion>>,
  TError,
  { id: string; data: BodyType<SaveAsVersionRequest> },
  TContext
> => {
  return useMutation(getSaveEditVersionMutationOptions(options));
};

export const getGetEditVersionUrl = (id: string, versionId: string) => {
  return `/api/assets/${id}/edit-versions/${versionId}`;
};

export const getEditVersion = async (
  id: string,
  versionId: string,
  options?: RequestInit,
): Promise<AssetVersion> => {
  return customFetch<AssetVersion>(getGetEditVersionUrl(id, versionId), {
    ...options,
    method: "GET",
  });
};

export const getGetEditVersionQueryKey = (id: string, versionId: string) => {
  return [`/api/assets/${id}/edit-versions/${versionId}`] as const;
};

export const getGetEditVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof getEditVersion>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  versionId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEditVersion>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEditVersionQueryKey(id, versionId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEditVersion>>> = ({
    signal,
  }) => getEditVersion(id, versionId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && versionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getEditVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetEditVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEditVersion>>
>;
export type GetEditVersionQueryError = ErrorType<unknown>;

export function useGetEditVersion<
  TData = Awaited<ReturnType<typeof getEditVersion>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  versionId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getEditVersion>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetEditVersionQueryOptions(id, versionId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getRevertEditVersionUrl = (id: string, versionId: string) => {
  return `/api/assets/${id}/edit-versions/${versionId}/revert`;
};

export const revertEditVersion = async (
  id: string,
  versionId: string,
  options?: RequestInit,
): Promise<AssetVersion> => {
  return customFetch<AssetVersion>(getRevertEditVersionUrl(id, versionId), {
    ...options,
    method: "POST",
  });
};

export const getRevertEditVersionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertEditVersion>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof revertEditVersion>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ["revertEditVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof revertEditVersion>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return revertEditVersion(id, versionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RevertEditVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof revertEditVersion>>
>;

export type RevertEditVersionMutationError = ErrorType<unknown>;

export const useRevertEditVersion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof revertEditVersion>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof revertEditVersion>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  return useMutation(getRevertEditVersionMutationOptions(options));
};

export const getListAssetJobsUrl = (id: string) => {
  return `/api/assets/${id}/jobs`;
};

export const listAssetJobs = async (
  id: string,
  options?: RequestInit,
): Promise<Job[]> => {
  return customFetch<Job[]>(getListAssetJobsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAssetJobsQueryKey = (id: string) => {
  return [`/api/assets/${id}/jobs`] as const;
};

export const getListAssetJobsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssetJobs>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssetJobs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAssetJobsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAssetJobs>>> = ({
    signal,
  }) => listAssetJobs(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAssetJobs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAssetJobsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAssetJobs>>
>;
export type ListAssetJobsQueryError = ErrorType<unknown>;

export function useListAssetJobs<
  TData = Awaited<ReturnType<typeof listAssetJobs>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssetJobs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAssetJobsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetJobUrl = (id: string) => {
  return `/api/jobs/${id}`;
};

export const getJob = async (
  id: string,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getGetJobUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetJobQueryKey = (id: string) => {
  return [`/api/jobs/${id}`] as const;
};

export const getGetJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getJob>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetJobQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({
    signal,
  }) => getJob(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>;
export type GetJobQueryError = ErrorType<unknown>;

export function useGetJob<
  TData = Awaited<ReturnType<typeof getJob>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetJobQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getRetryAssetJobUrl = (id: string, jobId: string) => {
  return `/api/assets/${id}/jobs/${jobId}/retry`;
};

export const retryAssetJob = async (
  id: string,
  jobId: string,
  options?: RequestInit,
): Promise<Job> => {
  return customFetch<Job>(getRetryAssetJobUrl(id, jobId), {
    ...options,
    method: "POST",
  });
};

export const getRetryAssetJobMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryAssetJob>>,
    TError,
    { id: string; jobId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof retryAssetJob>>,
  TError,
  { id: string; jobId: string },
  TContext
> => {
  const mutationKey = ["retryAssetJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof retryAssetJob>>,
    { id: string; jobId: string }
  > = (props) => {
    const { id, jobId } = props ?? {};

    return retryAssetJob(id, jobId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RetryAssetJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof retryAssetJob>>
>;

export type RetryAssetJobMutationError = ErrorType<unknown>;

export const useRetryAssetJob = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof retryAssetJob>>,
    TError,
    { id: string; jobId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof retryAssetJob>>,
  TError,
  { id: string; jobId: string },
  TContext
> => {
  return useMutation(getRetryAssetJobMutationOptions(options));
};

export const getListPresetsUrl = () => {
  return `/api/presets`;
};

export const listPresets = async (options?: RequestInit): Promise<Preset[]> => {
  return customFetch<Preset[]>(getListPresetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPresetsQueryKey = () => {
  return [`/api/presets`] as const;
};

export const getListPresetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPresets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPresets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPresetsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPresets>>> = ({
    signal,
  }) => listPresets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPresets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPresetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPresets>>
>;
export type ListPresetsQueryError = ErrorType<unknown>;

export function useListPresets<
  TData = Awaited<ReturnType<typeof listPresets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPresets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPresetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreatePresetUrl = () => {
  return `/api/presets`;
};

export const createPreset = async (
  newPreset: NewPreset,
  options?: RequestInit,
): Promise<Preset> => {
  return customFetch<Preset>(getCreatePresetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(newPreset),
  });
};

export const getCreatePresetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPreset>>,
    TError,
    { data: BodyType<NewPreset> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPreset>>,
  TError,
  { data: BodyType<NewPreset> },
  TContext
> => {
  const mutationKey = ["createPreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPreset>>,
    { data: BodyType<NewPreset> }
  > = (props) => {
    const { data } = props ?? {};

    return createPreset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPreset>>
>;
export type CreatePresetMutationBody = BodyType<NewPreset>;
export type CreatePresetMutationError = ErrorType<unknown>;

export const useCreatePreset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPreset>>,
    TError,
    { data: BodyType<NewPreset> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPreset>>,
  TError,
  { data: BodyType<NewPreset> },
  TContext
> => {
  return useMutation(getCreatePresetMutationOptions(options));
};

export const getUpdatePresetUrl = (id: string) => {
  return `/api/presets/${id}`;
};

export const updatePreset = async (
  id: string,
  presetUpdate: PresetUpdate,
  options?: RequestInit,
): Promise<Preset> => {
  return customFetch<Preset>(getUpdatePresetUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(presetUpdate),
  });
};

export const getUpdatePresetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePreset>>,
    TError,
    { id: string; data: BodyType<PresetUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePreset>>,
  TError,
  { id: string; data: BodyType<PresetUpdate> },
  TContext
> => {
  const mutationKey = ["updatePreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePreset>>,
    { id: string; data: BodyType<PresetUpdate> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updatePreset(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePreset>>
>;
export type UpdatePresetMutationBody = BodyType<PresetUpdate>;
export type UpdatePresetMutationError = ErrorType<unknown>;

export const useUpdatePreset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePreset>>,
    TError,
    { id: string; data: BodyType<PresetUpdate> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updatePreset>>,
  TError,
  { id: string; data: BodyType<PresetUpdate> },
  TContext
> => {
  return useMutation(getUpdatePresetMutationOptions(options));
};

export const getDeletePresetUrl = (id: string) => {
  return `/api/presets/${id}`;
};

export const deletePreset = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeletePresetUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeletePresetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePreset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deletePreset>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deletePreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deletePreset>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deletePreset(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeletePresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deletePreset>>
>;

export type DeletePresetMutationError = ErrorType<unknown>;

export const useDeletePreset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deletePreset>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deletePreset>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeletePresetMutationOptions(options));
};

export const getListAssetAssignmentsUrl = (id: string) => {
  return `/api/assets/${id}/assignments`;
};

export const listAssetAssignments = async (
  id: string,
  options?: RequestInit,
): Promise<AssetAssignment[]> => {
  return customFetch<AssetAssignment[]>(getListAssetAssignmentsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAssetAssignmentsQueryKey = (id: string) => {
  return [`/api/assets/${id}/assignments`] as const;
};

export const getListAssetAssignmentsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssetAssignments>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssetAssignments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListAssetAssignmentsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAssetAssignments>>
  > = ({ signal }) => listAssetAssignments(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAssetAssignments>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAssetAssignmentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAssetAssignments>>
>;
export type ListAssetAssignmentsQueryError = ErrorType<unknown>;

export function useListAssetAssignments<
  TData = Awaited<ReturnType<typeof listAssetAssignments>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssetAssignments>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAssetAssignmentsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAddAssetAssignmentUrl = (id: string) => {
  return `/api/assets/${id}/assignments`;
};

export const addAssetAssignment = async (
  id: string,
  addAssignmentRequest: AddAssignmentRequest,
  options?: RequestInit,
): Promise<AssetAssignment> => {
  return customFetch<AssetAssignment>(getAddAssetAssignmentUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addAssignmentRequest),
  });
};

export const getAddAssetAssignmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAssetAssignment>>,
    TError,
    { id: string; data: BodyType<AddAssignmentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addAssetAssignment>>,
  TError,
  { id: string; data: BodyType<AddAssignmentRequest> },
  TContext
> => {
  const mutationKey = ["addAssetAssignment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addAssetAssignment>>,
    { id: string; data: BodyType<AddAssignmentRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return addAssetAssignment(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddAssetAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof addAssetAssignment>>
>;
export type AddAssetAssignmentMutationBody = BodyType<AddAssignmentRequest>;
export type AddAssetAssignmentMutationError = ErrorType<unknown>;

export const useAddAssetAssignment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addAssetAssignment>>,
    TError,
    { id: string; data: BodyType<AddAssignmentRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof addAssetAssignment>>,
  TError,
  { id: string; data: BodyType<AddAssignmentRequest> },
  TContext
> => {
  return useMutation(getAddAssetAssignmentMutationOptions(options));
};

export const getRemoveAssetAssignmentUrl = (id: string, customerId: string) => {
  return `/api/assets/${id}/assignments/${customerId}`;
};

export const removeAssetAssignment = async (
  id: string,
  customerId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getRemoveAssetAssignmentUrl(id, customerId), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveAssetAssignmentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAssetAssignment>>,
    TError,
    { id: string; customerId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeAssetAssignment>>,
  TError,
  { id: string; customerId: string },
  TContext
> => {
  const mutationKey = ["removeAssetAssignment"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeAssetAssignment>>,
    { id: string; customerId: string }
  > = (props) => {
    const { id, customerId } = props ?? {};

    return removeAssetAssignment(id, customerId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveAssetAssignmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeAssetAssignment>>
>;

export type RemoveAssetAssignmentMutationError = ErrorType<unknown>;

export const useRemoveAssetAssignment = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAssetAssignment>>,
    TError,
    { id: string; customerId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof removeAssetAssignment>>,
  TError,
  { id: string; customerId: string },
  TContext
> => {
  return useMutation(getRemoveAssetAssignmentMutationOptions(options));
};

/**
 * @summary List customer accounts available to assign to this asset
 */
export const getListCustomerCandidatesUrl = (id: string) => {
  return `/api/assets/${id}/customer-candidates`;
};

export const listCustomerCandidates = async (
  id: string,
  options?: RequestInit,
): Promise<CustomerCandidate[]> => {
  return customFetch<CustomerCandidate[]>(getListCustomerCandidatesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListCustomerCandidatesQueryKey = (id: string) => {
  return [`/api/assets/${id}/customer-candidates`] as const;
};

export const getListCustomerCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomerCandidates>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomerCandidates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCustomerCandidatesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCustomerCandidates>>
  > = ({ signal }) => listCustomerCandidates(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomerCandidates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomerCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomerCandidates>>
>;
export type ListCustomerCandidatesQueryError = ErrorType<unknown>;

/**
 * @summary List customer accounts available to assign to this asset
 */

export function useListCustomerCandidates<
  TData = Awaited<ReturnType<typeof listCustomerCandidates>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomerCandidates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomerCandidatesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Per-preset feedback session status + lock holder for the employee Creative Space
 */
export const getGetFeedbackOverviewUrl = (id: string) => {
  return `/api/assets/${id}/feedback-overview`;
};

export const getFeedbackOverview = async (
  id: string,
  options?: RequestInit,
): Promise<FeedbackOverview> => {
  return customFetch<FeedbackOverview>(getGetFeedbackOverviewUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetFeedbackOverviewQueryKey = (id: string) => {
  return [`/api/assets/${id}/feedback-overview`] as const;
};

export const getGetFeedbackOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof getFeedbackOverview>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFeedbackOverview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFeedbackOverviewQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFeedbackOverview>>
  > = ({ signal }) => getFeedbackOverview(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getFeedbackOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetFeedbackOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFeedbackOverview>>
>;
export type GetFeedbackOverviewQueryError = ErrorType<unknown>;

/**
 * @summary Per-preset feedback session status + lock holder for the employee Creative Space
 */

export function useGetFeedbackOverview<
  TData = Awaited<ReturnType<typeof getFeedbackOverview>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getFeedbackOverview>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFeedbackOverviewQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Employee sends one or more presets to assigned customers for review
 */
export const getSendForReviewUrl = (id: string) => {
  return `/api/assets/${id}/send-for-review`;
};

export const sendForReview = async (
  id: string,
  sendForReviewRequest: SendForReviewRequest,
  options?: RequestInit,
): Promise<FeedbackSession[]> => {
  return customFetch<FeedbackSession[]>(getSendForReviewUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendForReviewRequest),
  });
};

export const getSendForReviewMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendForReview>>,
    TError,
    { id: string; data: BodyType<SendForReviewRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendForReview>>,
  TError,
  { id: string; data: BodyType<SendForReviewRequest> },
  TContext
> => {
  const mutationKey = ["sendForReview"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendForReview>>,
    { id: string; data: BodyType<SendForReviewRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendForReview(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendForReviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendForReview>>
>;
export type SendForReviewMutationBody = BodyType<SendForReviewRequest>;
export type SendForReviewMutationError = ErrorType<unknown>;

/**
 * @summary Employee sends one or more presets to assigned customers for review
 */
export const useSendForReview = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendForReview>>,
    TError,
    { id: string; data: BodyType<SendForReviewRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendForReview>>,
  TError,
  { id: string; data: BodyType<SendForReviewRequest> },
  TContext
> => {
  return useMutation(getSendForReviewMutationOptions(options));
};

/**
 * @summary Employee marks the customer-approved version as the current/final version
 */
export const getFinalizeFeedbackSessionUrl = (
  id: string,
  sessionId: string,
) => {
  return `/api/assets/${id}/feedback-sessions/${sessionId}/finalize`;
};

export const finalizeFeedbackSession = async (
  id: string,
  sessionId: string,
  options?: RequestInit,
): Promise<FeedbackSession> => {
  return customFetch<FeedbackSession>(
    getFinalizeFeedbackSessionUrl(id, sessionId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getFinalizeFeedbackSessionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeFeedbackSession>>,
    TError,
    { id: string; sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof finalizeFeedbackSession>>,
  TError,
  { id: string; sessionId: string },
  TContext
> => {
  const mutationKey = ["finalizeFeedbackSession"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof finalizeFeedbackSession>>,
    { id: string; sessionId: string }
  > = (props) => {
    const { id, sessionId } = props ?? {};

    return finalizeFeedbackSession(id, sessionId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FinalizeFeedbackSessionMutationResult = NonNullable<
  Awaited<ReturnType<typeof finalizeFeedbackSession>>
>;

export type FinalizeFeedbackSessionMutationError = ErrorType<unknown>;

/**
 * @summary Employee marks the customer-approved version as the current/final version
 */
export const useFinalizeFeedbackSession = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof finalizeFeedbackSession>>,
    TError,
    { id: string; sessionId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof finalizeFeedbackSession>>,
  TError,
  { id: string; sessionId: string },
  TContext
> => {
  return useMutation(getFinalizeFeedbackSessionMutationOptions(options));
};

export const getListAssetActivitiesUrl = (id: string) => {
  return `/api/assets/${id}/activities`;
};

export const listAssetActivities = async (
  id: string,
  options?: RequestInit,
): Promise<FeedbackActivity[]> => {
  return customFetch<FeedbackActivity[]>(getListAssetActivitiesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListAssetActivitiesQueryKey = (id: string) => {
  return [`/api/assets/${id}/activities`] as const;
};

export const getListAssetActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssetActivities>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssetActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAssetActivitiesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAssetActivities>>
  > = ({ signal }) => listAssetActivities(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listAssetActivities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAssetActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAssetActivities>>
>;
export type ListAssetActivitiesQueryError = ErrorType<unknown>;

export function useListAssetActivities<
  TData = Awaited<ReturnType<typeof listAssetActivities>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listAssetActivities>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAssetActivitiesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListCustomerAssetsUrl = (params?: ListCustomerAssetsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/customer/assets?${stringifiedParams}`
    : `/api/customer/assets`;
};

export const listCustomerAssets = async (
  params?: ListCustomerAssetsParams,
  options?: RequestInit,
): Promise<CustomerAssetSummary[]> => {
  return customFetch<CustomerAssetSummary[]>(getListCustomerAssetsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListCustomerAssetsQueryKey = (
  params?: ListCustomerAssetsParams,
) => {
  return [`/api/customer/assets`, ...(params ? [params] : [])] as const;
};

export const getListCustomerAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomerAssets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomerAssetsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomerAssets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCustomerAssetsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCustomerAssets>>
  > = ({ signal }) => listCustomerAssets(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomerAssets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomerAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomerAssets>>
>;
export type ListCustomerAssetsQueryError = ErrorType<unknown>;

export function useListCustomerAssets<
  TData = Awaited<ReturnType<typeof listCustomerAssets>>,
  TError = ErrorType<unknown>,
>(
  params?: ListCustomerAssetsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listCustomerAssets>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomerAssetsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetCustomerAssetUrl = (id: string) => {
  return `/api/customer/assets/${id}`;
};

export const getCustomerAsset = async (
  id: string,
  options?: RequestInit,
): Promise<CustomerAssetDetail> => {
  return customFetch<CustomerAssetDetail>(getGetCustomerAssetUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetCustomerAssetQueryKey = (id: string) => {
  return [`/api/customer/assets/${id}`] as const;
};

export const getGetCustomerAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerAsset>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerAsset>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCustomerAssetQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerAsset>>
  > = ({ signal }) => getCustomerAsset(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerAsset>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerAsset>>
>;
export type GetCustomerAssetQueryError = ErrorType<unknown>;

export function useGetCustomerAsset<
  TData = Awaited<ReturnType<typeof getCustomerAsset>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerAsset>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomerAssetQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetCustomerFeedbackStateUrl = (
  id: string,
  params: GetCustomerFeedbackStateParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/customer/assets/${id}/feedback-state?${stringifiedParams}`
    : `/api/customer/assets/${id}/feedback-state`;
};

export const getCustomerFeedbackState = async (
  id: string,
  params: GetCustomerFeedbackStateParams,
  options?: RequestInit,
): Promise<CustomerFeedbackState> => {
  return customFetch<CustomerFeedbackState>(
    getGetCustomerFeedbackStateUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCustomerFeedbackStateQueryKey = (
  id: string,
  params?: GetCustomerFeedbackStateParams,
) => {
  return [
    `/api/customer/assets/${id}/feedback-state`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCustomerFeedbackStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomerFeedbackState>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetCustomerFeedbackStateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerFeedbackState>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCustomerFeedbackStateQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCustomerFeedbackState>>
  > = ({ signal }) =>
    getCustomerFeedbackState(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomerFeedbackState>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCustomerFeedbackStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomerFeedbackState>>
>;
export type GetCustomerFeedbackStateQueryError = ErrorType<unknown>;

export function useGetCustomerFeedbackState<
  TData = Awaited<ReturnType<typeof getCustomerFeedbackState>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: GetCustomerFeedbackStateParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCustomerFeedbackState>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCustomerFeedbackStateQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAcquireCustomerLockUrl = (id: string) => {
  return `/api/customer/assets/${id}/lock`;
};

export const acquireCustomerLock = async (
  id: string,
  customerLockRequest: CustomerLockRequest,
  options?: RequestInit,
): Promise<CustomerLockResult> => {
  return customFetch<CustomerLockResult>(getAcquireCustomerLockUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(customerLockRequest),
  });
};

export const getAcquireCustomerLockMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acquireCustomerLock>>,
    TError,
    { id: string; data: BodyType<CustomerLockRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acquireCustomerLock>>,
  TError,
  { id: string; data: BodyType<CustomerLockRequest> },
  TContext
> => {
  const mutationKey = ["acquireCustomerLock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acquireCustomerLock>>,
    { id: string; data: BodyType<CustomerLockRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return acquireCustomerLock(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcquireCustomerLockMutationResult = NonNullable<
  Awaited<ReturnType<typeof acquireCustomerLock>>
>;
export type AcquireCustomerLockMutationBody = BodyType<CustomerLockRequest>;
export type AcquireCustomerLockMutationError = ErrorType<unknown>;

export const useAcquireCustomerLock = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acquireCustomerLock>>,
    TError,
    { id: string; data: BodyType<CustomerLockRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acquireCustomerLock>>,
  TError,
  { id: string; data: BodyType<CustomerLockRequest> },
  TContext
> => {
  return useMutation(getAcquireCustomerLockMutationOptions(options));
};

export const getReleaseCustomerLockUrl = (
  id: string,
  params: ReleaseCustomerLockParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/customer/assets/${id}/lock?${stringifiedParams}`
    : `/api/customer/assets/${id}/lock`;
};

export const releaseCustomerLock = async (
  id: string,
  params: ReleaseCustomerLockParams,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getReleaseCustomerLockUrl(id, params), {
    ...options,
    method: "DELETE",
  });
};

export const getReleaseCustomerLockMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseCustomerLock>>,
    TError,
    { id: string; params: ReleaseCustomerLockParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof releaseCustomerLock>>,
  TError,
  { id: string; params: ReleaseCustomerLockParams },
  TContext
> => {
  const mutationKey = ["releaseCustomerLock"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof releaseCustomerLock>>,
    { id: string; params: ReleaseCustomerLockParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return releaseCustomerLock(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReleaseCustomerLockMutationResult = NonNullable<
  Awaited<ReturnType<typeof releaseCustomerLock>>
>;

export type ReleaseCustomerLockMutationError = ErrorType<unknown>;

export const useReleaseCustomerLock = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof releaseCustomerLock>>,
    TError,
    { id: string; params: ReleaseCustomerLockParams },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof releaseCustomerLock>>,
  TError,
  { id: string; params: ReleaseCustomerLockParams },
  TContext
> => {
  return useMutation(getReleaseCustomerLockMutationOptions(options));
};

export const getSaveCustomerDraftUrl = (id: string) => {
  return `/api/customer/assets/${id}/draft`;
};

export const saveCustomerDraft = async (
  id: string,
  saveCustomerDraftRequest: SaveCustomerDraftRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getSaveCustomerDraftUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(saveCustomerDraftRequest),
  });
};

export const getSaveCustomerDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCustomerDraft>>,
    TError,
    { id: string; data: BodyType<SaveCustomerDraftRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveCustomerDraft>>,
  TError,
  { id: string; data: BodyType<SaveCustomerDraftRequest> },
  TContext
> => {
  const mutationKey = ["saveCustomerDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveCustomerDraft>>,
    { id: string; data: BodyType<SaveCustomerDraftRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return saveCustomerDraft(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveCustomerDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveCustomerDraft>>
>;
export type SaveCustomerDraftMutationBody = BodyType<SaveCustomerDraftRequest>;
export type SaveCustomerDraftMutationError = ErrorType<unknown>;

export const useSaveCustomerDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCustomerDraft>>,
    TError,
    { id: string; data: BodyType<SaveCustomerDraftRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveCustomerDraft>>,
  TError,
  { id: string; data: BodyType<SaveCustomerDraftRequest> },
  TContext
> => {
  return useMutation(getSaveCustomerDraftMutationOptions(options));
};

export const getSendCustomerFeedbackUrl = (id: string) => {
  return `/api/customer/assets/${id}/send-feedback`;
};

export const sendCustomerFeedback = async (
  id: string,
  sendCustomerFeedbackRequest: SendCustomerFeedbackRequest,
  options?: RequestInit,
): Promise<CustomerFeedbackState> => {
  return customFetch<CustomerFeedbackState>(getSendCustomerFeedbackUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendCustomerFeedbackRequest),
  });
};

export const getSendCustomerFeedbackMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendCustomerFeedback>>,
    TError,
    { id: string; data: BodyType<SendCustomerFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendCustomerFeedback>>,
  TError,
  { id: string; data: BodyType<SendCustomerFeedbackRequest> },
  TContext
> => {
  const mutationKey = ["sendCustomerFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendCustomerFeedback>>,
    { id: string; data: BodyType<SendCustomerFeedbackRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendCustomerFeedback(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendCustomerFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendCustomerFeedback>>
>;
export type SendCustomerFeedbackMutationBody =
  BodyType<SendCustomerFeedbackRequest>;
export type SendCustomerFeedbackMutationError = ErrorType<unknown>;

export const useSendCustomerFeedback = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendCustomerFeedback>>,
    TError,
    { id: string; data: BodyType<SendCustomerFeedbackRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendCustomerFeedback>>,
  TError,
  { id: string; data: BodyType<SendCustomerFeedbackRequest> },
  TContext
> => {
  return useMutation(getSendCustomerFeedbackMutationOptions(options));
};

export const getApproveCustomerVersionUrl = (id: string) => {
  return `/api/customer/assets/${id}/approve`;
};

export const approveCustomerVersion = async (
  id: string,
  approveCustomerRequest: ApproveCustomerRequest,
  options?: RequestInit,
): Promise<CustomerFeedbackState> => {
  return customFetch<CustomerFeedbackState>(getApproveCustomerVersionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(approveCustomerRequest),
  });
};

export const getApproveCustomerVersionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveCustomerVersion>>,
    TError,
    { id: string; data: BodyType<ApproveCustomerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveCustomerVersion>>,
  TError,
  { id: string; data: BodyType<ApproveCustomerRequest> },
  TContext
> => {
  const mutationKey = ["approveCustomerVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveCustomerVersion>>,
    { id: string; data: BodyType<ApproveCustomerRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return approveCustomerVersion(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveCustomerVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveCustomerVersion>>
>;
export type ApproveCustomerVersionMutationBody =
  BodyType<ApproveCustomerRequest>;
export type ApproveCustomerVersionMutationError = ErrorType<unknown>;

export const useApproveCustomerVersion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveCustomerVersion>>,
    TError,
    { id: string; data: BodyType<ApproveCustomerRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveCustomerVersion>>,
  TError,
  { id: string; data: BodyType<ApproveCustomerRequest> },
  TContext
> => {
  return useMutation(getApproveCustomerVersionMutationOptions(options));
};

/**
 * @summary Aggregate activity feed across all assets assigned to the current customer
 */
export const getListCustomerActivitiesUrl = () => {
  return `/api/customer/activities`;
};

export const listCustomerActivities = async (
  options?: RequestInit,
): Promise<FeedbackActivity[]> => {
  return customFetch<FeedbackActivity[]>(getListCustomerActivitiesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCustomerActivitiesQueryKey = () => {
  return [`/api/customer/activities`] as const;
};

export const getListCustomerActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomerActivities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCustomerActivities>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListCustomerActivitiesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCustomerActivities>>
  > = ({ signal }) => listCustomerActivities({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomerActivities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCustomerActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomerActivities>>
>;
export type ListCustomerActivitiesQueryError = ErrorType<unknown>;

/**
 * @summary Aggregate activity feed across all assets assigned to the current customer
 */

export function useListCustomerActivities<
  TData = Awaited<ReturnType<typeof listCustomerActivities>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCustomerActivities>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCustomerActivitiesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListNotificationsUrl = (params?: ListNotificationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/notifications?${stringifiedParams}`
    : `/api/notifications`;
};

export const listNotifications = async (
  params?: ListNotificationsParams,
  options?: RequestInit,
): Promise<Notification[]> => {
  return customFetch<Notification[]>(getListNotificationsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListNotificationsQueryKey = (
  params?: ListNotificationsParams,
) => {
  return [`/api/notifications`, ...(params ? [params] : [])] as const;
};

export const getListNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListNotificationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listNotifications>>
  > = ({ signal }) => listNotifications(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListNotificationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listNotifications>>
>;
export type ListNotificationsQueryError = ErrorType<unknown>;

export function useListNotifications<
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ErrorType<unknown>,
>(
  params?: ListNotificationsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listNotifications>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListNotificationsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetNotificationUnreadCountUrl = () => {
  return `/api/notifications/unread-count`;
};

export const getNotificationUnreadCount = async (
  options?: RequestInit,
): Promise<GetNotificationUnreadCount200> => {
  return customFetch<GetNotificationUnreadCount200>(
    getGetNotificationUnreadCountUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNotificationUnreadCountQueryKey = () => {
  return [`/api/notifications/unread-count`] as const;
};

export const getGetNotificationUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetNotificationUnreadCountQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>
  > = ({ signal }) => getNotificationUnreadCount({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetNotificationUnreadCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationUnreadCount>>
>;
export type GetNotificationUnreadCountQueryError = ErrorType<unknown>;

export function useGetNotificationUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationUnreadCount>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationUnreadCount>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetNotificationUnreadCountQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMarkNotificationsReadUrl = () => {
  return `/api/notifications/mark-read`;
};

export const markNotificationsRead = async (
  markNotificationsReadRequest: MarkNotificationsReadRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getMarkNotificationsReadUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(markNotificationsReadRequest),
  });
};

export const getMarkNotificationsReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    TError,
    { data: BodyType<MarkNotificationsReadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markNotificationsRead>>,
  TError,
  { data: BodyType<MarkNotificationsReadRequest> },
  TContext
> => {
  const mutationKey = ["markNotificationsRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    { data: BodyType<MarkNotificationsReadRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return markNotificationsRead(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationsReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markNotificationsRead>>
>;
export type MarkNotificationsReadMutationBody =
  BodyType<MarkNotificationsReadRequest>;
export type MarkNotificationsReadMutationError = ErrorType<unknown>;

export const useMarkNotificationsRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markNotificationsRead>>,
    TError,
    { data: BodyType<MarkNotificationsReadRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markNotificationsRead>>,
  TError,
  { data: BodyType<MarkNotificationsReadRequest> },
  TContext
> => {
  return useMutation(getMarkNotificationsReadMutationOptions(options));
};

export const getAdminListClientsUrl = (params?: AdminListClientsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/clients?${stringifiedParams}`
    : `/api/admin/clients`;
};

export const adminListClients = async (
  params?: AdminListClientsParams,
  options?: RequestInit,
): Promise<AdminClientListResponse> => {
  return customFetch<AdminClientListResponse>(getAdminListClientsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getAdminListClientsQueryKey = (
  params?: AdminListClientsParams,
) => {
  return [`/api/admin/clients`, ...(params ? [params] : [])] as const;
};

export const getAdminListClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListClients>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListClientsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListClients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListClientsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListClients>>
  > = ({ signal }) => adminListClients(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListClients>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListClients>>
>;
export type AdminListClientsQueryError = ErrorType<unknown>;

export function useAdminListClients<
  TData = Awaited<ReturnType<typeof adminListClients>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListClientsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListClients>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListClientsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminGetClientUrl = (id: string) => {
  return `/api/admin/clients/${id}`;
};

export const adminGetClient = async (
  id: string,
  options?: RequestInit,
): Promise<AdminClientDetail> => {
  return customFetch<AdminClientDetail>(getAdminGetClientUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetClientQueryKey = (id: string) => {
  return [`/api/admin/clients/${id}`] as const;
};

export const getAdminGetClientQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetClient>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetClient>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetClientQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetClient>>> = ({
    signal,
  }) => adminGetClient(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetClient>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetClientQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetClient>>
>;
export type AdminGetClientQueryError = ErrorType<void>;

export function useAdminGetClient<
  TData = Awaited<ReturnType<typeof adminGetClient>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetClient>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetClientQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminGetClientUsageUrl = (
  id: string,
  params?: AdminGetClientUsageParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/clients/${id}/usage?${stringifiedParams}`
    : `/api/admin/clients/${id}/usage`;
};

export const adminGetClientUsage = async (
  id: string,
  params?: AdminGetClientUsageParams,
  options?: RequestInit,
): Promise<AdminUsageHistory> => {
  return customFetch<AdminUsageHistory>(getAdminGetClientUsageUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetClientUsageQueryKey = (
  id: string,
  params?: AdminGetClientUsageParams,
) => {
  return [
    `/api/admin/clients/${id}/usage`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminGetClientUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetClientUsage>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: AdminGetClientUsageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetClientUsage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetClientUsageQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetClientUsage>>
  > = ({ signal }) =>
    adminGetClientUsage(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetClientUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetClientUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetClientUsage>>
>;
export type AdminGetClientUsageQueryError = ErrorType<unknown>;

export function useAdminGetClientUsage<
  TData = Awaited<ReturnType<typeof adminGetClientUsage>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: AdminGetClientUsageParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetClientUsage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetClientUsageQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminAdjustCreditsUrl = (id: string) => {
  return `/api/admin/clients/${id}/credit-adjust`;
};

export const adminAdjustCredits = async (
  id: string,
  adminCreditAdjustRequest: AdminCreditAdjustRequest,
  options?: RequestInit,
): Promise<AdminCreditAdjustResponse> => {
  return customFetch<AdminCreditAdjustResponse>(getAdminAdjustCreditsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminCreditAdjustRequest),
  });
};

export const getAdminAdjustCreditsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminAdjustCredits>>,
    TError,
    { id: string; data: BodyType<AdminCreditAdjustRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminAdjustCredits>>,
  TError,
  { id: string; data: BodyType<AdminCreditAdjustRequest> },
  TContext
> => {
  const mutationKey = ["adminAdjustCredits"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminAdjustCredits>>,
    { id: string; data: BodyType<AdminCreditAdjustRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminAdjustCredits(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminAdjustCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminAdjustCredits>>
>;
export type AdminAdjustCreditsMutationBody = BodyType<AdminCreditAdjustRequest>;
export type AdminAdjustCreditsMutationError = ErrorType<void>;

export const useAdminAdjustCredits = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminAdjustCredits>>,
    TError,
    { id: string; data: BodyType<AdminCreditAdjustRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminAdjustCredits>>,
  TError,
  { id: string; data: BodyType<AdminCreditAdjustRequest> },
  TContext
> => {
  return useMutation(getAdminAdjustCreditsMutationOptions(options));
};

export const getAdminLockAccountUrl = (id: string) => {
  return `/api/admin/clients/${id}/lock`;
};

export const adminLockAccount = async (
  id: string,
  adminLockRequest: AdminLockRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getAdminLockAccountUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminLockRequest),
  });
};

export const getAdminLockAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminLockAccount>>,
    TError,
    { id: string; data: BodyType<AdminLockRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminLockAccount>>,
  TError,
  { id: string; data: BodyType<AdminLockRequest> },
  TContext
> => {
  const mutationKey = ["adminLockAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminLockAccount>>,
    { id: string; data: BodyType<AdminLockRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminLockAccount(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminLockAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminLockAccount>>
>;
export type AdminLockAccountMutationBody = BodyType<AdminLockRequest>;
export type AdminLockAccountMutationError = ErrorType<unknown>;

export const useAdminLockAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminLockAccount>>,
    TError,
    { id: string; data: BodyType<AdminLockRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminLockAccount>>,
  TError,
  { id: string; data: BodyType<AdminLockRequest> },
  TContext
> => {
  return useMutation(getAdminLockAccountMutationOptions(options));
};

export const getAdminUnlockAccountUrl = (id: string) => {
  return `/api/admin/clients/${id}/unlock`;
};

export const adminUnlockAccount = async (
  id: string,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getAdminUnlockAccountUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAdminUnlockAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUnlockAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUnlockAccount>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["adminUnlockAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUnlockAccount>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminUnlockAccount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUnlockAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUnlockAccount>>
>;

export type AdminUnlockAccountMutationError = ErrorType<unknown>;

export const useAdminUnlockAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUnlockAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUnlockAccount>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAdminUnlockAccountMutationOptions(options));
};

export const getAdminListPendingOrdersUrl = () => {
  return `/api/admin/reconciliation`;
};

export const adminListPendingOrders = async (
  options?: RequestInit,
): Promise<AdminReconciliationResponse> => {
  return customFetch<AdminReconciliationResponse>(
    getAdminListPendingOrdersUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListPendingOrdersQueryKey = () => {
  return [`/api/admin/reconciliation`] as const;
};

export const getAdminListPendingOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListPendingOrders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPendingOrders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListPendingOrdersQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListPendingOrders>>
  > = ({ signal }) => adminListPendingOrders({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListPendingOrders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListPendingOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListPendingOrders>>
>;
export type AdminListPendingOrdersQueryError = ErrorType<unknown>;

export function useAdminListPendingOrders<
  TData = Awaited<ReturnType<typeof adminListPendingOrders>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPendingOrders>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListPendingOrdersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminConfirmOrderUrl = (id: string) => {
  return `/api/admin/orders/${id}/confirm`;
};

export const adminConfirmOrder = async (
  id: string,
  options?: RequestInit,
): Promise<AdminConfirmOrderResponse> => {
  return customFetch<AdminConfirmOrderResponse>(getAdminConfirmOrderUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAdminConfirmOrderMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminConfirmOrder>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminConfirmOrder>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["adminConfirmOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminConfirmOrder>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminConfirmOrder(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminConfirmOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminConfirmOrder>>
>;

export type AdminConfirmOrderMutationError = ErrorType<void>;

export const useAdminConfirmOrder = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminConfirmOrder>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminConfirmOrder>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAdminConfirmOrderMutationOptions(options));
};

/**
 * @summary List VAT e-invoice requests (queue) or issued invoices
 */
export const getAdminListVatInvoicesUrl = (
  params?: AdminListVatInvoicesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/vat-invoices?${stringifiedParams}`
    : `/api/admin/vat-invoices`;
};

export const adminListVatInvoices = async (
  params?: AdminListVatInvoicesParams,
  options?: RequestInit,
): Promise<AdminVatInvoiceListResponse> => {
  return customFetch<AdminVatInvoiceListResponse>(
    getAdminListVatInvoicesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListVatInvoicesQueryKey = (
  params?: AdminListVatInvoicesParams,
) => {
  return [`/api/admin/vat-invoices`, ...(params ? [params] : [])] as const;
};

export const getAdminListVatInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListVatInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListVatInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListVatInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListVatInvoicesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListVatInvoices>>
  > = ({ signal }) =>
    adminListVatInvoices(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListVatInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListVatInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListVatInvoices>>
>;
export type AdminListVatInvoicesQueryError = ErrorType<unknown>;

/**
 * @summary List VAT e-invoice requests (queue) or issued invoices
 */

export function useAdminListVatInvoices<
  TData = Awaited<ReturnType<typeof adminListVatInvoices>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListVatInvoicesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListVatInvoices>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListVatInvoicesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Count pending (requested) VAT invoice requests for the nav badge
 */
export const getAdminCountPendingVatInvoicesUrl = () => {
  return `/api/admin/vat-invoices/pending-count`;
};

export const adminCountPendingVatInvoices = async (
  options?: RequestInit,
): Promise<AdminCountResponse> => {
  return customFetch<AdminCountResponse>(getAdminCountPendingVatInvoicesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminCountPendingVatInvoicesQueryKey = () => {
  return [`/api/admin/vat-invoices/pending-count`] as const;
};

export const getAdminCountPendingVatInvoicesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminCountPendingVatInvoices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminCountPendingVatInvoices>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminCountPendingVatInvoicesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminCountPendingVatInvoices>>
  > = ({ signal }) =>
    adminCountPendingVatInvoices({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminCountPendingVatInvoices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminCountPendingVatInvoicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminCountPendingVatInvoices>>
>;
export type AdminCountPendingVatInvoicesQueryError = ErrorType<unknown>;

/**
 * @summary Count pending (requested) VAT invoice requests for the nav badge
 */

export function useAdminCountPendingVatInvoices<
  TData = Awaited<ReturnType<typeof adminCountPendingVatInvoices>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminCountPendingVatInvoices>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminCountPendingVatInvoicesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a VAT invoice request as issued and notify the buyer
 */
export const getAdminIssueVatInvoiceUrl = (orderId: string) => {
  return `/api/admin/vat-invoices/${orderId}/issue`;
};

export const adminIssueVatInvoice = async (
  orderId: string,
  adminIssueVatInvoiceRequest: AdminIssueVatInvoiceRequest,
  options?: RequestInit,
): Promise<AdminIssueVatInvoiceResponse> => {
  return customFetch<AdminIssueVatInvoiceResponse>(
    getAdminIssueVatInvoiceUrl(orderId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminIssueVatInvoiceRequest),
    },
  );
};

export const getAdminIssueVatInvoiceMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminIssueVatInvoice>>,
    TError,
    { orderId: string; data: BodyType<AdminIssueVatInvoiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminIssueVatInvoice>>,
  TError,
  { orderId: string; data: BodyType<AdminIssueVatInvoiceRequest> },
  TContext
> => {
  const mutationKey = ["adminIssueVatInvoice"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminIssueVatInvoice>>,
    { orderId: string; data: BodyType<AdminIssueVatInvoiceRequest> }
  > = (props) => {
    const { orderId, data } = props ?? {};

    return adminIssueVatInvoice(orderId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminIssueVatInvoiceMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminIssueVatInvoice>>
>;
export type AdminIssueVatInvoiceMutationBody =
  BodyType<AdminIssueVatInvoiceRequest>;
export type AdminIssueVatInvoiceMutationError = ErrorType<void>;

/**
 * @summary Mark a VAT invoice request as issued and notify the buyer
 */
export const useAdminIssueVatInvoice = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminIssueVatInvoice>>,
    TError,
    { orderId: string; data: BodyType<AdminIssueVatInvoiceRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminIssueVatInvoice>>,
  TError,
  { orderId: string; data: BodyType<AdminIssueVatInvoiceRequest> },
  TContext
> => {
  return useMutation(getAdminIssueVatInvoiceMutationOptions(options));
};

export const getAdminGetReportsUrl = () => {
  return `/api/admin/reports`;
};

export const adminGetReports = async (
  options?: RequestInit,
): Promise<AdminReports> => {
  return customFetch<AdminReports>(getAdminGetReportsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetReportsQueryKey = () => {
  return [`/api/admin/reports`] as const;
};

export const getAdminGetReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetReports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetReportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetReports>>> = ({
    signal,
  }) => adminGetReports({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetReports>>
>;
export type AdminGetReportsQueryError = ErrorType<unknown>;

export function useAdminGetReports<
  TData = Awaited<ReturnType<typeof adminGetReports>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetReports>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetReportsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Studio-only: confirm access + whether the caller can operate.
 */
export const getAdaptiveLocationAccessUrl = () => {
  return `/api/adaptive-location/access`;
};

export const adaptiveLocationAccess = async (
  options?: RequestInit,
): Promise<AdaptiveLocationAccess> => {
  return customFetch<AdaptiveLocationAccess>(getAdaptiveLocationAccessUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdaptiveLocationAccessQueryKey = () => {
  return [`/api/adaptive-location/access`] as const;
};

export const getAdaptiveLocationAccessQueryOptions = <
  TData = Awaited<ReturnType<typeof adaptiveLocationAccess>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adaptiveLocationAccess>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdaptiveLocationAccessQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adaptiveLocationAccess>>
  > = ({ signal }) => adaptiveLocationAccess({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adaptiveLocationAccess>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdaptiveLocationAccessQueryResult = NonNullable<
  Awaited<ReturnType<typeof adaptiveLocationAccess>>
>;
export type AdaptiveLocationAccessQueryError = ErrorType<unknown>;

/**
 * @summary Studio-only: confirm access + whether the caller can operate.
 */

export function useAdaptiveLocationAccess<
  TData = Awaited<ReturnType<typeof adaptiveLocationAccess>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adaptiveLocationAccess>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdaptiveLocationAccessQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary SYSTEM_ADMIN read-only cross-account Adaptive Location activity.
 */
export const getAdminAdaptiveLocationOverviewUrl = () => {
  return `/api/admin/adaptive-location/overview`;
};

export const adminAdaptiveLocationOverview = async (
  options?: RequestInit,
): Promise<AdaptiveLocationOverview> => {
  return customFetch<AdaptiveLocationOverview>(
    getAdminAdaptiveLocationOverviewUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminAdaptiveLocationOverviewQueryKey = () => {
  return [`/api/admin/adaptive-location/overview`] as const;
};

export const getAdminAdaptiveLocationOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof adminAdaptiveLocationOverview>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminAdaptiveLocationOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminAdaptiveLocationOverviewQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminAdaptiveLocationOverview>>
  > = ({ signal }) =>
    adminAdaptiveLocationOverview({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminAdaptiveLocationOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminAdaptiveLocationOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminAdaptiveLocationOverview>>
>;
export type AdminAdaptiveLocationOverviewQueryError = ErrorType<unknown>;

/**
 * @summary SYSTEM_ADMIN read-only cross-account Adaptive Location activity.
 */

export function useAdminAdaptiveLocationOverview<
  TData = Awaited<ReturnType<typeof adminAdaptiveLocationOverview>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminAdaptiveLocationOverview>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminAdaptiveLocationOverviewQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminSetMemberPasswordUrl = (id: string, userId: string) => {
  return `/api/admin/clients/${id}/members/${userId}/set-password`;
};

export const adminSetMemberPassword = async (
  id: string,
  userId: string,
  adminSetPasswordRequest: AdminSetPasswordRequest,
  options?: RequestInit,
): Promise<AdminSetPasswordResponse> => {
  return customFetch<AdminSetPasswordResponse>(
    getAdminSetMemberPasswordUrl(id, userId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminSetPasswordRequest),
    },
  );
};

export const getAdminSetMemberPasswordMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetMemberPassword>>,
    TError,
    { id: string; userId: string; data: BodyType<AdminSetPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetMemberPassword>>,
  TError,
  { id: string; userId: string; data: BodyType<AdminSetPasswordRequest> },
  TContext
> => {
  const mutationKey = ["adminSetMemberPassword"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetMemberPassword>>,
    { id: string; userId: string; data: BodyType<AdminSetPasswordRequest> }
  > = (props) => {
    const { id, userId, data } = props ?? {};

    return adminSetMemberPassword(id, userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetMemberPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetMemberPassword>>
>;
export type AdminSetMemberPasswordMutationBody =
  BodyType<AdminSetPasswordRequest>;
export type AdminSetMemberPasswordMutationError = ErrorType<unknown>;

export const useAdminSetMemberPassword = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetMemberPassword>>,
    TError,
    { id: string; userId: string; data: BodyType<AdminSetPasswordRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetMemberPassword>>,
  TError,
  { id: string; userId: string; data: BodyType<AdminSetPasswordRequest> },
  TContext
> => {
  return useMutation(getAdminSetMemberPasswordMutationOptions(options));
};

export const getAdminResendVerificationUrl = (id: string, userId: string) => {
  return `/api/admin/clients/${id}/members/${userId}/resend-verification`;
};

export const adminResendVerification = async (
  id: string,
  userId: string,
  options?: RequestInit,
): Promise<AdminResendVerificationResponse> => {
  return customFetch<AdminResendVerificationResponse>(
    getAdminResendVerificationUrl(id, userId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAdminResendVerificationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminResendVerification>>,
    TError,
    { id: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminResendVerification>>,
  TError,
  { id: string; userId: string },
  TContext
> => {
  const mutationKey = ["adminResendVerification"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminResendVerification>>,
    { id: string; userId: string }
  > = (props) => {
    const { id, userId } = props ?? {};

    return adminResendVerification(id, userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminResendVerificationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminResendVerification>>
>;

export type AdminResendVerificationMutationError = ErrorType<unknown>;

export const useAdminResendVerification = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminResendVerification>>,
    TError,
    { id: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminResendVerification>>,
  TError,
  { id: string; userId: string },
  TContext
> => {
  return useMutation(getAdminResendVerificationMutationOptions(options));
};

export const getAdminInviteMemberUrl = (id: string) => {
  return `/api/admin/clients/${id}/members/invite`;
};

export const adminInviteMember = async (
  id: string,
  adminInviteMemberRequest: AdminInviteMemberRequest,
  options?: RequestInit,
): Promise<AdminInviteMemberResponse> => {
  return customFetch<AdminInviteMemberResponse>(getAdminInviteMemberUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminInviteMemberRequest),
  });
};

export const getAdminInviteMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminInviteMember>>,
    TError,
    { id: string; data: BodyType<AdminInviteMemberRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminInviteMember>>,
  TError,
  { id: string; data: BodyType<AdminInviteMemberRequest> },
  TContext
> => {
  const mutationKey = ["adminInviteMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminInviteMember>>,
    { id: string; data: BodyType<AdminInviteMemberRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminInviteMember(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminInviteMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminInviteMember>>
>;
export type AdminInviteMemberMutationBody = BodyType<AdminInviteMemberRequest>;
export type AdminInviteMemberMutationError = ErrorType<unknown>;

export const useAdminInviteMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminInviteMember>>,
    TError,
    { id: string; data: BodyType<AdminInviteMemberRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminInviteMember>>,
  TError,
  { id: string; data: BodyType<AdminInviteMemberRequest> },
  TContext
> => {
  return useMutation(getAdminInviteMemberMutationOptions(options));
};

export const getAdminRemoveMemberUrl = (id: string, userId: string) => {
  return `/api/admin/clients/${id}/members/${userId}`;
};

export const adminRemoveMember = async (
  id: string,
  userId: string,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getAdminRemoveMemberUrl(id, userId), {
    ...options,
    method: "DELETE",
  });
};

export const getAdminRemoveMemberMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRemoveMember>>,
    TError,
    { id: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRemoveMember>>,
  TError,
  { id: string; userId: string },
  TContext
> => {
  const mutationKey = ["adminRemoveMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRemoveMember>>,
    { id: string; userId: string }
  > = (props) => {
    const { id, userId } = props ?? {};

    return adminRemoveMember(id, userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRemoveMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRemoveMember>>
>;

export type AdminRemoveMemberMutationError = ErrorType<unknown>;

export const useAdminRemoveMember = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRemoveMember>>,
    TError,
    { id: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminRemoveMember>>,
  TError,
  { id: string; userId: string },
  TContext
> => {
  return useMutation(getAdminRemoveMemberMutationOptions(options));
};

/**
 * @summary Permanently delete a user and all their personal data (GDPR erasure; audited)
 */
export const getAdminHardDeleteUserUrl = (id: string, userId: string) => {
  return `/api/admin/clients/${id}/members/${userId}/hard-delete`;
};

export const adminHardDeleteUser = async (
  id: string,
  userId: string,
  options?: RequestInit,
): Promise<AdminHardDeleteUserResponse> => {
  return customFetch<AdminHardDeleteUserResponse>(
    getAdminHardDeleteUserUrl(id, userId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAdminHardDeleteUserMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteUser>>,
    TError,
    { id: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminHardDeleteUser>>,
  TError,
  { id: string; userId: string },
  TContext
> => {
  const mutationKey = ["adminHardDeleteUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminHardDeleteUser>>,
    { id: string; userId: string }
  > = (props) => {
    const { id, userId } = props ?? {};

    return adminHardDeleteUser(id, userId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminHardDeleteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminHardDeleteUser>>
>;

export type AdminHardDeleteUserMutationError = ErrorType<void>;

/**
 * @summary Permanently delete a user and all their personal data (GDPR erasure; audited)
 */
export const useAdminHardDeleteUser = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminHardDeleteUser>>,
    TError,
    { id: string; userId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminHardDeleteUser>>,
  TError,
  { id: string; userId: string },
  TContext
> => {
  return useMutation(getAdminHardDeleteUserMutationOptions(options));
};

export const getAdminChangeMemberRoleUrl = (id: string, userId: string) => {
  return `/api/admin/clients/${id}/members/${userId}/role`;
};

export const adminChangeMemberRole = async (
  id: string,
  userId: string,
  adminChangeRoleRequest: AdminChangeRoleRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getAdminChangeMemberRoleUrl(id, userId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminChangeRoleRequest),
  });
};

export const getAdminChangeMemberRoleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminChangeMemberRole>>,
    TError,
    { id: string; userId: string; data: BodyType<AdminChangeRoleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminChangeMemberRole>>,
  TError,
  { id: string; userId: string; data: BodyType<AdminChangeRoleRequest> },
  TContext
> => {
  const mutationKey = ["adminChangeMemberRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminChangeMemberRole>>,
    { id: string; userId: string; data: BodyType<AdminChangeRoleRequest> }
  > = (props) => {
    const { id, userId, data } = props ?? {};

    return adminChangeMemberRole(id, userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminChangeMemberRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminChangeMemberRole>>
>;
export type AdminChangeMemberRoleMutationBody =
  BodyType<AdminChangeRoleRequest>;
export type AdminChangeMemberRoleMutationError = ErrorType<unknown>;

export const useAdminChangeMemberRole = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminChangeMemberRole>>,
    TError,
    { id: string; userId: string; data: BodyType<AdminChangeRoleRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminChangeMemberRole>>,
  TError,
  { id: string; userId: string; data: BodyType<AdminChangeRoleRequest> },
  TContext
> => {
  return useMutation(getAdminChangeMemberRoleMutationOptions(options));
};

export const getAdminSetSeatsUrl = (id: string) => {
  return `/api/admin/clients/${id}/seats`;
};

export const adminSetSeats = async (
  id: string,
  adminSetSeatsRequest: AdminSetSeatsRequest,
  options?: RequestInit,
): Promise<AdminSetSeatsResponse> => {
  return customFetch<AdminSetSeatsResponse>(getAdminSetSeatsUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminSetSeatsRequest),
  });
};

export const getAdminSetSeatsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetSeats>>,
    TError,
    { id: string; data: BodyType<AdminSetSeatsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetSeats>>,
  TError,
  { id: string; data: BodyType<AdminSetSeatsRequest> },
  TContext
> => {
  const mutationKey = ["adminSetSeats"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetSeats>>,
    { id: string; data: BodyType<AdminSetSeatsRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSetSeats(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetSeatsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetSeats>>
>;
export type AdminSetSeatsMutationBody = BodyType<AdminSetSeatsRequest>;
export type AdminSetSeatsMutationError = ErrorType<unknown>;

export const useAdminSetSeats = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetSeats>>,
    TError,
    { id: string; data: BodyType<AdminSetSeatsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetSeats>>,
  TError,
  { id: string; data: BodyType<AdminSetSeatsRequest> },
  TContext
> => {
  return useMutation(getAdminSetSeatsMutationOptions(options));
};

export const getAdminUpdateSubscriptionUrl = (id: string) => {
  return `/api/admin/clients/${id}/subscription`;
};

export const adminUpdateSubscription = async (
  id: string,
  adminUpdateSubscriptionRequest: AdminUpdateSubscriptionRequest,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getAdminUpdateSubscriptionUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminUpdateSubscriptionRequest),
  });
};

export const getAdminUpdateSubscriptionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateSubscription>>,
    TError,
    { id: string; data: BodyType<AdminUpdateSubscriptionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateSubscription>>,
  TError,
  { id: string; data: BodyType<AdminUpdateSubscriptionRequest> },
  TContext
> => {
  const mutationKey = ["adminUpdateSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateSubscription>>,
    { id: string; data: BodyType<AdminUpdateSubscriptionRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminUpdateSubscription(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateSubscription>>
>;
export type AdminUpdateSubscriptionMutationBody =
  BodyType<AdminUpdateSubscriptionRequest>;
export type AdminUpdateSubscriptionMutationError = ErrorType<unknown>;

export const useAdminUpdateSubscription = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateSubscription>>,
    TError,
    { id: string; data: BodyType<AdminUpdateSubscriptionRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateSubscription>>,
  TError,
  { id: string; data: BodyType<AdminUpdateSubscriptionRequest> },
  TContext
> => {
  return useMutation(getAdminUpdateSubscriptionMutationOptions(options));
};

export const getAdminRefundOrderUrl = (id: string) => {
  return `/api/admin/orders/${id}/refund`;
};

export const adminRefundOrder = async (
  id: string,
  adminRefundRequest: AdminRefundRequest,
  options?: RequestInit,
): Promise<AdminRefundResponse> => {
  return customFetch<AdminRefundResponse>(getAdminRefundOrderUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminRefundRequest),
  });
};

export const getAdminRefundOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRefundOrder>>,
    TError,
    { id: string; data: BodyType<AdminRefundRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRefundOrder>>,
  TError,
  { id: string; data: BodyType<AdminRefundRequest> },
  TContext
> => {
  const mutationKey = ["adminRefundOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRefundOrder>>,
    { id: string; data: BodyType<AdminRefundRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminRefundOrder(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRefundOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRefundOrder>>
>;
export type AdminRefundOrderMutationBody = BodyType<AdminRefundRequest>;
export type AdminRefundOrderMutationError = ErrorType<unknown>;

export const useAdminRefundOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRefundOrder>>,
    TError,
    { id: string; data: BodyType<AdminRefundRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminRefundOrder>>,
  TError,
  { id: string; data: BodyType<AdminRefundRequest> },
  TContext
> => {
  return useMutation(getAdminRefundOrderMutationOptions(options));
};

export const getAdminListContactMessagesUrl = (
  params?: AdminListContactMessagesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/contact-messages?${stringifiedParams}`
    : `/api/admin/contact-messages`;
};

export const adminListContactMessages = async (
  params?: AdminListContactMessagesParams,
  options?: RequestInit,
): Promise<AdminContactMessagesResponse> => {
  return customFetch<AdminContactMessagesResponse>(
    getAdminListContactMessagesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListContactMessagesQueryKey = (
  params?: AdminListContactMessagesParams,
) => {
  return [`/api/admin/contact-messages`, ...(params ? [params] : [])] as const;
};

export const getAdminListContactMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListContactMessages>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListContactMessagesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListContactMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListContactMessagesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListContactMessages>>
  > = ({ signal }) =>
    adminListContactMessages(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListContactMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListContactMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListContactMessages>>
>;
export type AdminListContactMessagesQueryError = ErrorType<unknown>;

export function useAdminListContactMessages<
  TData = Awaited<ReturnType<typeof adminListContactMessages>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListContactMessagesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListContactMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListContactMessagesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminCountUnhandledContactsUrl = () => {
  return `/api/admin/contact-messages/unhandled-count`;
};

export const adminCountUnhandledContacts = async (
  options?: RequestInit,
): Promise<AdminCountResponse> => {
  return customFetch<AdminCountResponse>(getAdminCountUnhandledContactsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminCountUnhandledContactsQueryKey = () => {
  return [`/api/admin/contact-messages/unhandled-count`] as const;
};

export const getAdminCountUnhandledContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminCountUnhandledContacts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminCountUnhandledContacts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminCountUnhandledContactsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminCountUnhandledContacts>>
  > = ({ signal }) =>
    adminCountUnhandledContacts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminCountUnhandledContacts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminCountUnhandledContactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminCountUnhandledContacts>>
>;
export type AdminCountUnhandledContactsQueryError = ErrorType<unknown>;

export function useAdminCountUnhandledContacts<
  TData = Awaited<ReturnType<typeof adminCountUnhandledContacts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminCountUnhandledContacts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminCountUnhandledContactsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminSetContactHandledUrl = (id: string) => {
  return `/api/admin/contact-messages/${id}/handled`;
};

export const adminSetContactHandled = async (
  id: string,
  adminContactHandledRequest: AdminContactHandledRequest,
  options?: RequestInit,
): Promise<AdminContactMessage> => {
  return customFetch<AdminContactMessage>(getAdminSetContactHandledUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminContactHandledRequest),
  });
};

export const getAdminSetContactHandledMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetContactHandled>>,
    TError,
    { id: string; data: BodyType<AdminContactHandledRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetContactHandled>>,
  TError,
  { id: string; data: BodyType<AdminContactHandledRequest> },
  TContext
> => {
  const mutationKey = ["adminSetContactHandled"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetContactHandled>>,
    { id: string; data: BodyType<AdminContactHandledRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSetContactHandled(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetContactHandledMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetContactHandled>>
>;
export type AdminSetContactHandledMutationBody =
  BodyType<AdminContactHandledRequest>;
export type AdminSetContactHandledMutationError = ErrorType<unknown>;

export const useAdminSetContactHandled = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetContactHandled>>,
    TError,
    { id: string; data: BodyType<AdminContactHandledRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetContactHandled>>,
  TError,
  { id: string; data: BodyType<AdminContactHandledRequest> },
  TContext
> => {
  return useMutation(getAdminSetContactHandledMutationOptions(options));
};

export const getAdminGetSettingsUrl = () => {
  return `/api/admin/settings`;
};

export const adminGetSettings = async (
  options?: RequestInit,
): Promise<AdminSettings> => {
  return customFetch<AdminSettings>(getAdminGetSettingsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetSettingsQueryKey = () => {
  return [`/api/admin/settings`] as const;
};

export const getAdminGetSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetSettingsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetSettings>>
  > = ({ signal }) => adminGetSettings({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetSettings>>
>;
export type AdminGetSettingsQueryError = ErrorType<unknown>;

export function useAdminGetSettings<
  TData = Awaited<ReturnType<typeof adminGetSettings>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetSettings>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetSettingsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminSetTaskCostsUrl = () => {
  return `/api/admin/settings/task-costs`;
};

export const adminSetTaskCosts = async (
  adminTaskCostsRequest: AdminTaskCostsRequest,
  options?: RequestInit,
): Promise<AdminTaskCostsResponse> => {
  return customFetch<AdminTaskCostsResponse>(getAdminSetTaskCostsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminTaskCostsRequest),
  });
};

export const getAdminSetTaskCostsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetTaskCosts>>,
    TError,
    { data: BodyType<AdminTaskCostsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetTaskCosts>>,
  TError,
  { data: BodyType<AdminTaskCostsRequest> },
  TContext
> => {
  const mutationKey = ["adminSetTaskCosts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetTaskCosts>>,
    { data: BodyType<AdminTaskCostsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminSetTaskCosts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetTaskCostsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetTaskCosts>>
>;
export type AdminSetTaskCostsMutationBody = BodyType<AdminTaskCostsRequest>;
export type AdminSetTaskCostsMutationError = ErrorType<unknown>;

export const useAdminSetTaskCosts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetTaskCosts>>,
    TError,
    { data: BodyType<AdminTaskCostsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetTaskCosts>>,
  TError,
  { data: BodyType<AdminTaskCostsRequest> },
  TContext
> => {
  return useMutation(getAdminSetTaskCostsMutationOptions(options));
};

export const getAdminSetFeatureFlagsUrl = () => {
  return `/api/admin/settings/feature-flags`;
};

export const adminSetFeatureFlags = async (
  adminFeatureFlagsRequest: AdminFeatureFlagsRequest,
  options?: RequestInit,
): Promise<AdminFeatureFlagsResponse> => {
  return customFetch<AdminFeatureFlagsResponse>(getAdminSetFeatureFlagsUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminFeatureFlagsRequest),
  });
};

export const getAdminSetFeatureFlagsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetFeatureFlags>>,
    TError,
    { data: BodyType<AdminFeatureFlagsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetFeatureFlags>>,
  TError,
  { data: BodyType<AdminFeatureFlagsRequest> },
  TContext
> => {
  const mutationKey = ["adminSetFeatureFlags"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetFeatureFlags>>,
    { data: BodyType<AdminFeatureFlagsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminSetFeatureFlags(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetFeatureFlagsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetFeatureFlags>>
>;
export type AdminSetFeatureFlagsMutationBody =
  BodyType<AdminFeatureFlagsRequest>;
export type AdminSetFeatureFlagsMutationError = ErrorType<unknown>;

export const useAdminSetFeatureFlags = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetFeatureFlags>>,
    TError,
    { data: BodyType<AdminFeatureFlagsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetFeatureFlags>>,
  TError,
  { data: BodyType<AdminFeatureFlagsRequest> },
  TContext
> => {
  return useMutation(getAdminSetFeatureFlagsMutationOptions(options));
};

export const getAdminSetTopupPricingUrl = () => {
  return `/api/admin/settings/topup-pricing`;
};

export const adminSetTopupPricing = async (
  adminTopupPricingRequest: AdminTopupPricingRequest,
  options?: RequestInit,
): Promise<AdminTopupPricingResponse> => {
  return customFetch<AdminTopupPricingResponse>(getAdminSetTopupPricingUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminTopupPricingRequest),
  });
};

export const getAdminSetTopupPricingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetTopupPricing>>,
    TError,
    { data: BodyType<AdminTopupPricingRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetTopupPricing>>,
  TError,
  { data: BodyType<AdminTopupPricingRequest> },
  TContext
> => {
  const mutationKey = ["adminSetTopupPricing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetTopupPricing>>,
    { data: BodyType<AdminTopupPricingRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminSetTopupPricing(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetTopupPricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetTopupPricing>>
>;
export type AdminSetTopupPricingMutationBody =
  BodyType<AdminTopupPricingRequest>;
export type AdminSetTopupPricingMutationError = ErrorType<unknown>;

export const useAdminSetTopupPricing = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetTopupPricing>>,
    TError,
    { data: BodyType<AdminTopupPricingRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetTopupPricing>>,
  TError,
  { data: BodyType<AdminTopupPricingRequest> },
  TContext
> => {
  return useMutation(getAdminSetTopupPricingMutationOptions(options));
};

export const getAdminSetReferralRewardsUrl = () => {
  return `/api/admin/settings/referral-rewards`;
};

export const adminSetReferralRewards = async (
  adminReferralRewardsRequest: AdminReferralRewardsRequest,
  options?: RequestInit,
): Promise<AdminReferralRewardsResponse> => {
  return customFetch<AdminReferralRewardsResponse>(
    getAdminSetReferralRewardsUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminReferralRewardsRequest),
    },
  );
};

export const getAdminSetReferralRewardsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetReferralRewards>>,
    TError,
    { data: BodyType<AdminReferralRewardsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetReferralRewards>>,
  TError,
  { data: BodyType<AdminReferralRewardsRequest> },
  TContext
> => {
  const mutationKey = ["adminSetReferralRewards"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetReferralRewards>>,
    { data: BodyType<AdminReferralRewardsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminSetReferralRewards(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetReferralRewardsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetReferralRewards>>
>;
export type AdminSetReferralRewardsMutationBody =
  BodyType<AdminReferralRewardsRequest>;
export type AdminSetReferralRewardsMutationError = ErrorType<unknown>;

export const useAdminSetReferralRewards = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetReferralRewards>>,
    TError,
    { data: BodyType<AdminReferralRewardsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetReferralRewards>>,
  TError,
  { data: BodyType<AdminReferralRewardsRequest> },
  TContext
> => {
  return useMutation(getAdminSetReferralRewardsMutationOptions(options));
};

export const getAdminSetWelcomeTrialCreditsUrl = () => {
  return `/api/admin/settings/welcome-trial-credits`;
};

export const adminSetWelcomeTrialCredits = async (
  adminWelcomeTrialCreditsRequest: AdminWelcomeTrialCreditsRequest,
  options?: RequestInit,
): Promise<AdminWelcomeTrialCreditsResponse> => {
  return customFetch<AdminWelcomeTrialCreditsResponse>(
    getAdminSetWelcomeTrialCreditsUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminWelcomeTrialCreditsRequest),
    },
  );
};

export const getAdminSetWelcomeTrialCreditsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetWelcomeTrialCredits>>,
    TError,
    { data: BodyType<AdminWelcomeTrialCreditsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetWelcomeTrialCredits>>,
  TError,
  { data: BodyType<AdminWelcomeTrialCreditsRequest> },
  TContext
> => {
  const mutationKey = ["adminSetWelcomeTrialCredits"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetWelcomeTrialCredits>>,
    { data: BodyType<AdminWelcomeTrialCreditsRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminSetWelcomeTrialCredits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetWelcomeTrialCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetWelcomeTrialCredits>>
>;
export type AdminSetWelcomeTrialCreditsMutationBody =
  BodyType<AdminWelcomeTrialCreditsRequest>;
export type AdminSetWelcomeTrialCreditsMutationError = ErrorType<unknown>;

export const useAdminSetWelcomeTrialCredits = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetWelcomeTrialCredits>>,
    TError,
    { data: BodyType<AdminWelcomeTrialCreditsRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetWelcomeTrialCredits>>,
  TError,
  { data: BodyType<AdminWelcomeTrialCreditsRequest> },
  TContext
> => {
  return useMutation(getAdminSetWelcomeTrialCreditsMutationOptions(options));
};

/**
 * @summary All referral conversions (totals + per-row detail)
 */
export const getAdminGetReferralsUrl = () => {
  return `/api/admin/referrals`;
};

export const adminGetReferrals = async (
  options?: RequestInit,
): Promise<AdminReferralOverview> => {
  return customFetch<AdminReferralOverview>(getAdminGetReferralsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetReferralsQueryKey = () => {
  return [`/api/admin/referrals`] as const;
};

export const getAdminGetReferralsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetReferrals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetReferrals>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetReferralsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetReferrals>>
  > = ({ signal }) => adminGetReferrals({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetReferrals>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetReferralsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetReferrals>>
>;
export type AdminGetReferralsQueryError = ErrorType<unknown>;

/**
 * @summary All referral conversions (totals + per-row detail)
 */

export function useAdminGetReferrals<
  TData = Awaited<ReturnType<typeof adminGetReferrals>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetReferrals>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetReferralsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Set the affiliate default commission rate + minimum payout
 */
export const getAdminSetAffiliateProgramUrl = () => {
  return `/api/admin/settings/affiliate-program`;
};

export const adminSetAffiliateProgram = async (
  adminAffiliateProgramRequest: AdminAffiliateProgramRequest,
  options?: RequestInit,
): Promise<AdminAffiliateProgramResponse> => {
  return customFetch<AdminAffiliateProgramResponse>(
    getAdminSetAffiliateProgramUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminAffiliateProgramRequest),
    },
  );
};

export const getAdminSetAffiliateProgramMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetAffiliateProgram>>,
    TError,
    { data: BodyType<AdminAffiliateProgramRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetAffiliateProgram>>,
  TError,
  { data: BodyType<AdminAffiliateProgramRequest> },
  TContext
> => {
  const mutationKey = ["adminSetAffiliateProgram"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetAffiliateProgram>>,
    { data: BodyType<AdminAffiliateProgramRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminSetAffiliateProgram(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetAffiliateProgramMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetAffiliateProgram>>
>;
export type AdminSetAffiliateProgramMutationBody =
  BodyType<AdminAffiliateProgramRequest>;
export type AdminSetAffiliateProgramMutationError = ErrorType<unknown>;

/**
 * @summary Set the affiliate default commission rate + minimum payout
 */
export const useAdminSetAffiliateProgram = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetAffiliateProgram>>,
    TError,
    { data: BodyType<AdminAffiliateProgramRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetAffiliateProgram>>,
  TError,
  { data: BodyType<AdminAffiliateProgramRequest> },
  TContext
> => {
  return useMutation(getAdminSetAffiliateProgramMutationOptions(options));
};

/**
 * @summary The client's affiliate state (enabled, rate, balances)
 */
export const getAdminGetClientAffiliateUrl = (id: string) => {
  return `/api/admin/clients/${id}/affiliate`;
};

export const adminGetClientAffiliate = async (
  id: string,
  options?: RequestInit,
): Promise<AdminAffiliateStatus> => {
  return customFetch<AdminAffiliateStatus>(getAdminGetClientAffiliateUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getAdminGetClientAffiliateQueryKey = (id: string) => {
  return [`/api/admin/clients/${id}/affiliate`] as const;
};

export const getAdminGetClientAffiliateQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetClientAffiliate>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetClientAffiliate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetClientAffiliateQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetClientAffiliate>>
  > = ({ signal }) =>
    adminGetClientAffiliate(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetClientAffiliate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetClientAffiliateQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetClientAffiliate>>
>;
export type AdminGetClientAffiliateQueryError = ErrorType<void>;

/**
 * @summary The client's affiliate state (enabled, rate, balances)
 */

export function useAdminGetClientAffiliate<
  TData = Awaited<ReturnType<typeof adminGetClientAffiliate>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetClientAffiliate>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetClientAffiliateQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Enable/disable affiliate status and set the commission rate
 */
export const getAdminSetClientAffiliateUrl = (id: string) => {
  return `/api/admin/clients/${id}/affiliate`;
};

export const adminSetClientAffiliate = async (
  id: string,
  adminAffiliateStatusRequest: AdminAffiliateStatusRequest,
  options?: RequestInit,
): Promise<AdminAffiliateStatus> => {
  return customFetch<AdminAffiliateStatus>(getAdminSetClientAffiliateUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminAffiliateStatusRequest),
  });
};

export const getAdminSetClientAffiliateMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetClientAffiliate>>,
    TError,
    { id: string; data: BodyType<AdminAffiliateStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetClientAffiliate>>,
  TError,
  { id: string; data: BodyType<AdminAffiliateStatusRequest> },
  TContext
> => {
  const mutationKey = ["adminSetClientAffiliate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetClientAffiliate>>,
    { id: string; data: BodyType<AdminAffiliateStatusRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSetClientAffiliate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetClientAffiliateMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetClientAffiliate>>
>;
export type AdminSetClientAffiliateMutationBody =
  BodyType<AdminAffiliateStatusRequest>;
export type AdminSetClientAffiliateMutationError = ErrorType<void>;

/**
 * @summary Enable/disable affiliate status and set the commission rate
 */
export const useAdminSetClientAffiliate = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetClientAffiliate>>,
    TError,
    { id: string; data: BodyType<AdminAffiliateStatusRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetClientAffiliate>>,
  TError,
  { id: string; data: BodyType<AdminAffiliateStatusRequest> },
  TContext
> => {
  return useMutation(getAdminSetClientAffiliateMutationOptions(options));
};

/**
 * @summary The affiliate payout settlement queue
 */
export const getAdminListAffiliatePayoutsUrl = (
  params?: AdminListAffiliatePayoutsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/affiliates/payouts?${stringifiedParams}`
    : `/api/admin/affiliates/payouts`;
};

export const adminListAffiliatePayouts = async (
  params?: AdminListAffiliatePayoutsParams,
  options?: RequestInit,
): Promise<AdminAffiliatePayoutList> => {
  return customFetch<AdminAffiliatePayoutList>(
    getAdminListAffiliatePayoutsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListAffiliatePayoutsQueryKey = (
  params?: AdminListAffiliatePayoutsParams,
) => {
  return [
    `/api/admin/affiliates/payouts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAdminListAffiliatePayoutsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListAffiliatePayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListAffiliatePayoutsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListAffiliatePayouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListAffiliatePayoutsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListAffiliatePayouts>>
  > = ({ signal }) =>
    adminListAffiliatePayouts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListAffiliatePayouts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListAffiliatePayoutsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListAffiliatePayouts>>
>;
export type AdminListAffiliatePayoutsQueryError = ErrorType<unknown>;

/**
 * @summary The affiliate payout settlement queue
 */

export function useAdminListAffiliatePayouts<
  TData = Awaited<ReturnType<typeof adminListAffiliatePayouts>>,
  TError = ErrorType<unknown>,
>(
  params?: AdminListAffiliatePayoutsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminListAffiliatePayouts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListAffiliatePayoutsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Mark a payout as paid (idempotent; notifies the affiliate)
 */
export const getAdminMarkAffiliatePayoutPaidUrl = (id: string) => {
  return `/api/admin/affiliates/payouts/${id}/mark-paid`;
};

export const adminMarkAffiliatePayoutPaid = async (
  id: string,
  adminMarkPayoutPaidRequest: AdminMarkPayoutPaidRequest,
  options?: RequestInit,
): Promise<AffiliatePayoutSettlement> => {
  return customFetch<AffiliatePayoutSettlement>(
    getAdminMarkAffiliatePayoutPaidUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminMarkPayoutPaidRequest),
    },
  );
};

export const getAdminMarkAffiliatePayoutPaidMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMarkAffiliatePayoutPaid>>,
    TError,
    { id: string; data: BodyType<AdminMarkPayoutPaidRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminMarkAffiliatePayoutPaid>>,
  TError,
  { id: string; data: BodyType<AdminMarkPayoutPaidRequest> },
  TContext
> => {
  const mutationKey = ["adminMarkAffiliatePayoutPaid"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminMarkAffiliatePayoutPaid>>,
    { id: string; data: BodyType<AdminMarkPayoutPaidRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminMarkAffiliatePayoutPaid(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMarkAffiliatePayoutPaidMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminMarkAffiliatePayoutPaid>>
>;
export type AdminMarkAffiliatePayoutPaidMutationBody =
  BodyType<AdminMarkPayoutPaidRequest>;
export type AdminMarkAffiliatePayoutPaidMutationError = ErrorType<void>;

/**
 * @summary Mark a payout as paid (idempotent; notifies the affiliate)
 */
export const useAdminMarkAffiliatePayoutPaid = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminMarkAffiliatePayoutPaid>>,
    TError,
    { id: string; data: BodyType<AdminMarkPayoutPaidRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminMarkAffiliatePayoutPaid>>,
  TError,
  { id: string; data: BodyType<AdminMarkPayoutPaidRequest> },
  TContext
> => {
  return useMutation(getAdminMarkAffiliatePayoutPaidMutationOptions(options));
};

/**
 * @summary Reject a payout request (releases the locked amount)
 */
export const getAdminRejectAffiliatePayoutUrl = (id: string) => {
  return `/api/admin/affiliates/payouts/${id}/reject`;
};

export const adminRejectAffiliatePayout = async (
  id: string,
  adminRejectPayoutRequest: AdminRejectPayoutRequest,
  options?: RequestInit,
): Promise<AffiliatePayoutSettlement> => {
  return customFetch<AffiliatePayoutSettlement>(
    getAdminRejectAffiliatePayoutUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminRejectPayoutRequest),
    },
  );
};

export const getAdminRejectAffiliatePayoutMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRejectAffiliatePayout>>,
    TError,
    { id: string; data: BodyType<AdminRejectPayoutRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminRejectAffiliatePayout>>,
  TError,
  { id: string; data: BodyType<AdminRejectPayoutRequest> },
  TContext
> => {
  const mutationKey = ["adminRejectAffiliatePayout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminRejectAffiliatePayout>>,
    { id: string; data: BodyType<AdminRejectPayoutRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminRejectAffiliatePayout(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRejectAffiliatePayoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminRejectAffiliatePayout>>
>;
export type AdminRejectAffiliatePayoutMutationBody =
  BodyType<AdminRejectPayoutRequest>;
export type AdminRejectAffiliatePayoutMutationError = ErrorType<void>;

/**
 * @summary Reject a payout request (releases the locked amount)
 */
export const useAdminRejectAffiliatePayout = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminRejectAffiliatePayout>>,
    TError,
    { id: string; data: BodyType<AdminRejectPayoutRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminRejectAffiliatePayout>>,
  TError,
  { id: string; data: BodyType<AdminRejectPayoutRequest> },
  TContext
> => {
  return useMutation(getAdminRejectAffiliatePayoutMutationOptions(options));
};

export const getAdminGetClientTopupPricingUrl = (id: string) => {
  return `/api/admin/clients/${id}/topup-pricing`;
};

export const adminGetClientTopupPricing = async (
  id: string,
  options?: RequestInit,
): Promise<AdminAccountTopupPricingResponse> => {
  return customFetch<AdminAccountTopupPricingResponse>(
    getAdminGetClientTopupPricingUrl(id),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetClientTopupPricingQueryKey = (id: string) => {
  return [`/api/admin/clients/${id}/topup-pricing`] as const;
};

export const getAdminGetClientTopupPricingQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetClientTopupPricing>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetClientTopupPricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetClientTopupPricingQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetClientTopupPricing>>
  > = ({ signal }) =>
    adminGetClientTopupPricing(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetClientTopupPricing>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetClientTopupPricingQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetClientTopupPricing>>
>;
export type AdminGetClientTopupPricingQueryError = ErrorType<void>;

export function useAdminGetClientTopupPricing<
  TData = Awaited<ReturnType<typeof adminGetClientTopupPricing>>,
  TError = ErrorType<void>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof adminGetClientTopupPricing>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetClientTopupPricingQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminSetClientTopupPricingUrl = (id: string) => {
  return `/api/admin/clients/${id}/topup-pricing`;
};

export const adminSetClientTopupPricing = async (
  id: string,
  adminTopupPricingRequest: AdminTopupPricingRequest,
  options?: RequestInit,
): Promise<AdminAccountTopupPricingResponse> => {
  return customFetch<AdminAccountTopupPricingResponse>(
    getAdminSetClientTopupPricingUrl(id),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminTopupPricingRequest),
    },
  );
};

export const getAdminSetClientTopupPricingMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetClientTopupPricing>>,
    TError,
    { id: string; data: BodyType<AdminTopupPricingRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSetClientTopupPricing>>,
  TError,
  { id: string; data: BodyType<AdminTopupPricingRequest> },
  TContext
> => {
  const mutationKey = ["adminSetClientTopupPricing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSetClientTopupPricing>>,
    { id: string; data: BodyType<AdminTopupPricingRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSetClientTopupPricing(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSetClientTopupPricingMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSetClientTopupPricing>>
>;
export type AdminSetClientTopupPricingMutationBody =
  BodyType<AdminTopupPricingRequest>;
export type AdminSetClientTopupPricingMutationError = ErrorType<void>;

export const useAdminSetClientTopupPricing = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSetClientTopupPricing>>,
    TError,
    { id: string; data: BodyType<AdminTopupPricingRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSetClientTopupPricing>>,
  TError,
  { id: string; data: BodyType<AdminTopupPricingRequest> },
  TContext
> => {
  return useMutation(getAdminSetClientTopupPricingMutationOptions(options));
};

export const getAdminListPresetsUrl = () => {
  return `/api/admin/presets`;
};

export const adminListPresets = async (
  options?: RequestInit,
): Promise<AdminPresetsResponse> => {
  return customFetch<AdminPresetsResponse>(getAdminListPresetsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminListPresetsQueryKey = () => {
  return [`/api/admin/presets`] as const;
};

export const getAdminListPresetsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListPresets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPresets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminListPresetsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListPresets>>
  > = ({ signal }) => adminListPresets({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListPresets>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminListPresetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListPresets>>
>;
export type AdminListPresetsQueryError = ErrorType<unknown>;

export function useAdminListPresets<
  TData = Awaited<ReturnType<typeof adminListPresets>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminListPresets>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminListPresetsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getAdminCreatePresetUrl = () => {
  return `/api/admin/presets`;
};

export const adminCreatePreset = async (
  adminCreatePresetRequest: AdminCreatePresetRequest,
  options?: RequestInit,
): Promise<AdminPreset> => {
  return customFetch<AdminPreset>(getAdminCreatePresetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminCreatePresetRequest),
  });
};

export const getAdminCreatePresetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreatePreset>>,
    TError,
    { data: BodyType<AdminCreatePresetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreatePreset>>,
  TError,
  { data: BodyType<AdminCreatePresetRequest> },
  TContext
> => {
  const mutationKey = ["adminCreatePreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreatePreset>>,
    { data: BodyType<AdminCreatePresetRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreatePreset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreatePresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreatePreset>>
>;
export type AdminCreatePresetMutationBody = BodyType<AdminCreatePresetRequest>;
export type AdminCreatePresetMutationError = ErrorType<unknown>;

export const useAdminCreatePreset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreatePreset>>,
    TError,
    { data: BodyType<AdminCreatePresetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminCreatePreset>>,
  TError,
  { data: BodyType<AdminCreatePresetRequest> },
  TContext
> => {
  return useMutation(getAdminCreatePresetMutationOptions(options));
};

export const getAdminUpdatePresetUrl = (id: string) => {
  return `/api/admin/presets/${id}`;
};

export const adminUpdatePreset = async (
  id: string,
  adminUpdatePresetRequest: AdminUpdatePresetRequest,
  options?: RequestInit,
): Promise<AdminPreset> => {
  return customFetch<AdminPreset>(getAdminUpdatePresetUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminUpdatePresetRequest),
  });
};

export const getAdminUpdatePresetMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdatePreset>>,
    TError,
    { id: string; data: BodyType<AdminUpdatePresetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdatePreset>>,
  TError,
  { id: string; data: BodyType<AdminUpdatePresetRequest> },
  TContext
> => {
  const mutationKey = ["adminUpdatePreset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdatePreset>>,
    { id: string; data: BodyType<AdminUpdatePresetRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminUpdatePreset(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdatePresetMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdatePreset>>
>;
export type AdminUpdatePresetMutationBody = BodyType<AdminUpdatePresetRequest>;
export type AdminUpdatePresetMutationError = ErrorType<unknown>;

export const useAdminUpdatePreset = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdatePreset>>,
    TError,
    { id: string; data: BodyType<AdminUpdatePresetRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdatePreset>>,
  TError,
  { id: string; data: BodyType<AdminUpdatePresetRequest> },
  TContext
> => {
  return useMutation(getAdminUpdatePresetMutationOptions(options));
};

/**
 * Public (unauthenticated) endpoint that captures a contact-form submission so leads are stored reliably instead of relying on a client-side mailto link. Rate-limited per IP and protected by a honeypot field.

 * @summary Submit a message from the public Contact page
 */
export const getSubmitContactMessageUrl = () => {
  return `/api/contact`;
};

export const submitContactMessage = async (
  newContactMessage: NewContactMessage,
  options?: RequestInit,
): Promise<ContactMessageResult> => {
  return customFetch<ContactMessageResult>(getSubmitContactMessageUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(newContactMessage),
  });
};

export const getSubmitContactMessageMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitContactMessage>>,
    TError,
    { data: BodyType<NewContactMessage> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof submitContactMessage>>,
  TError,
  { data: BodyType<NewContactMessage> },
  TContext
> => {
  const mutationKey = ["submitContactMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitContactMessage>>,
    { data: BodyType<NewContactMessage> }
  > = (props) => {
    const { data } = props ?? {};

    return submitContactMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitContactMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof submitContactMessage>>
>;
export type SubmitContactMessageMutationBody = BodyType<NewContactMessage>;
export type SubmitContactMessageMutationError = ErrorType<void>;

/**
 * @summary Submit a message from the public Contact page
 */
export const useSubmitContactMessage = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof submitContactMessage>>,
    TError,
    { data: BodyType<NewContactMessage> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof submitContactMessage>>,
  TError,
  { data: BodyType<NewContactMessage> },
  TContext
> => {
  return useMutation(getSubmitContactMessageMutationOptions(options));
};

/**
 * @summary Old-structure (63) provinces from the local mirror
 */
export const getListVnOldProvincesUrl = (params?: ListVnOldProvincesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vn-addresses/old/provinces?${stringifiedParams}`
    : `/api/vn-addresses/old/provinces`;
};

export const listVnOldProvinces = async (
  params?: ListVnOldProvincesParams,
  options?: RequestInit,
): Promise<VnOldProvince[]> => {
  return customFetch<VnOldProvince[]>(getListVnOldProvincesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVnOldProvincesQueryKey = (
  params?: ListVnOldProvincesParams,
) => {
  return [
    `/api/vn-addresses/old/provinces`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListVnOldProvincesQueryOptions = <
  TData = Awaited<ReturnType<typeof listVnOldProvinces>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVnOldProvincesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnOldProvinces>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVnOldProvincesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVnOldProvinces>>
  > = ({ signal }) => listVnOldProvinces(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVnOldProvinces>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVnOldProvincesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVnOldProvinces>>
>;
export type ListVnOldProvincesQueryError = ErrorType<unknown>;

/**
 * @summary Old-structure (63) provinces from the local mirror
 */

export function useListVnOldProvinces<
  TData = Awaited<ReturnType<typeof listVnOldProvinces>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVnOldProvincesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnOldProvinces>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVnOldProvincesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Old-structure districts from the local mirror
 */
export const getListVnOldDistrictsUrl = (params?: ListVnOldDistrictsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vn-addresses/old/districts?${stringifiedParams}`
    : `/api/vn-addresses/old/districts`;
};

export const listVnOldDistricts = async (
  params?: ListVnOldDistrictsParams,
  options?: RequestInit,
): Promise<VnOldDistrict[]> => {
  return customFetch<VnOldDistrict[]>(getListVnOldDistrictsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVnOldDistrictsQueryKey = (
  params?: ListVnOldDistrictsParams,
) => {
  return [
    `/api/vn-addresses/old/districts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListVnOldDistrictsQueryOptions = <
  TData = Awaited<ReturnType<typeof listVnOldDistricts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVnOldDistrictsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnOldDistricts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVnOldDistrictsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVnOldDistricts>>
  > = ({ signal }) => listVnOldDistricts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVnOldDistricts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVnOldDistrictsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVnOldDistricts>>
>;
export type ListVnOldDistrictsQueryError = ErrorType<unknown>;

/**
 * @summary Old-structure districts from the local mirror
 */

export function useListVnOldDistricts<
  TData = Awaited<ReturnType<typeof listVnOldDistricts>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVnOldDistrictsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnOldDistricts>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVnOldDistrictsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Old-structure wards (requires provinceCode, districtCode or search)
 */
export const getListVnOldWardsUrl = (params?: ListVnOldWardsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vn-addresses/old/wards?${stringifiedParams}`
    : `/api/vn-addresses/old/wards`;
};

export const listVnOldWards = async (
  params?: ListVnOldWardsParams,
  options?: RequestInit,
): Promise<VnOldWard[]> => {
  return customFetch<VnOldWard[]>(getListVnOldWardsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVnOldWardsQueryKey = (params?: ListVnOldWardsParams) => {
  return [`/api/vn-addresses/old/wards`, ...(params ? [params] : [])] as const;
};

export const getListVnOldWardsQueryOptions = <
  TData = Awaited<ReturnType<typeof listVnOldWards>>,
  TError = ErrorType<void>,
>(
  params?: ListVnOldWardsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnOldWards>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListVnOldWardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listVnOldWards>>> = ({
    signal,
  }) => listVnOldWards(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVnOldWards>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVnOldWardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVnOldWards>>
>;
export type ListVnOldWardsQueryError = ErrorType<void>;

/**
 * @summary Old-structure wards (requires provinceCode, districtCode or search)
 */

export function useListVnOldWards<
  TData = Awaited<ReturnType<typeof listVnOldWards>>,
  TError = ErrorType<void>,
>(
  params?: ListVnOldWardsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnOldWards>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVnOldWardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary New-structure (34) provinces from the local mirror
 */
export const getListVnNewProvincesUrl = (params?: ListVnNewProvincesParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vn-addresses/new/provinces?${stringifiedParams}`
    : `/api/vn-addresses/new/provinces`;
};

export const listVnNewProvinces = async (
  params?: ListVnNewProvincesParams,
  options?: RequestInit,
): Promise<VnNewProvince[]> => {
  return customFetch<VnNewProvince[]>(getListVnNewProvincesUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVnNewProvincesQueryKey = (
  params?: ListVnNewProvincesParams,
) => {
  return [
    `/api/vn-addresses/new/provinces`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListVnNewProvincesQueryOptions = <
  TData = Awaited<ReturnType<typeof listVnNewProvinces>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVnNewProvincesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnNewProvinces>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListVnNewProvincesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVnNewProvinces>>
  > = ({ signal }) => listVnNewProvinces(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVnNewProvinces>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVnNewProvincesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVnNewProvinces>>
>;
export type ListVnNewProvincesQueryError = ErrorType<unknown>;

/**
 * @summary New-structure (34) provinces from the local mirror
 */

export function useListVnNewProvinces<
  TData = Awaited<ReturnType<typeof listVnNewProvinces>>,
  TError = ErrorType<unknown>,
>(
  params?: ListVnNewProvincesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnNewProvinces>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVnNewProvincesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary New-structure wards (requires provinceCode or search)
 */
export const getListVnNewWardsUrl = (params?: ListVnNewWardsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/vn-addresses/new/wards?${stringifiedParams}`
    : `/api/vn-addresses/new/wards`;
};

export const listVnNewWards = async (
  params?: ListVnNewWardsParams,
  options?: RequestInit,
): Promise<VnNewWard[]> => {
  return customFetch<VnNewWard[]>(getListVnNewWardsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListVnNewWardsQueryKey = (params?: ListVnNewWardsParams) => {
  return [`/api/vn-addresses/new/wards`, ...(params ? [params] : [])] as const;
};

export const getListVnNewWardsQueryOptions = <
  TData = Awaited<ReturnType<typeof listVnNewWards>>,
  TError = ErrorType<void>,
>(
  params?: ListVnNewWardsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnNewWards>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListVnNewWardsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listVnNewWards>>> = ({
    signal,
  }) => listVnNewWards(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVnNewWards>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListVnNewWardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVnNewWards>>
>;
export type ListVnNewWardsQueryError = ErrorType<void>;

/**
 * @summary New-structure wards (requires provinceCode or search)
 */

export function useListVnNewWards<
  TData = Awaited<ReturnType<typeof listVnNewWards>>,
  TError = ErrorType<void>,
>(
  params?: ListVnNewWardsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listVnNewWards>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListVnNewWardsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Latest VN address mirror sync run
 */
export const getAdminGetVnAddressSyncStatusUrl = () => {
  return `/api/admin/vn-addresses/sync-status`;
};

export const adminGetVnAddressSyncStatus = async (
  options?: RequestInit,
): Promise<VnAddressSyncStatusResponse> => {
  return customFetch<VnAddressSyncStatusResponse>(
    getAdminGetVnAddressSyncStatusUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetVnAddressSyncStatusQueryKey = () => {
  return [`/api/admin/vn-addresses/sync-status`] as const;
};

export const getAdminGetVnAddressSyncStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetVnAddressSyncStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetVnAddressSyncStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetVnAddressSyncStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetVnAddressSyncStatus>>
  > = ({ signal }) =>
    adminGetVnAddressSyncStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetVnAddressSyncStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AdminGetVnAddressSyncStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetVnAddressSyncStatus>>
>;
export type AdminGetVnAddressSyncStatusQueryError = ErrorType<unknown>;

/**
 * @summary Latest VN address mirror sync run
 */

export function useAdminGetVnAddressSyncStatus<
  TData = Awaited<ReturnType<typeof adminGetVnAddressSyncStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof adminGetVnAddressSyncStatus>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAdminGetVnAddressSyncStatusQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Trigger a full resync of the VN address mirror
 */
export const getAdminStartVnAddressSyncUrl = () => {
  return `/api/admin/vn-addresses/sync`;
};

export const adminStartVnAddressSync = async (
  options?: RequestInit,
): Promise<VnAddressSyncStartResponse> => {
  return customFetch<VnAddressSyncStartResponse>(
    getAdminStartVnAddressSyncUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getAdminStartVnAddressSyncMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStartVnAddressSync>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStartVnAddressSync>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["adminStartVnAddressSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStartVnAddressSync>>,
    void
  > = () => {
    return adminStartVnAddressSync(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStartVnAddressSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStartVnAddressSync>>
>;

export type AdminStartVnAddressSyncMutationError = ErrorType<void>;

/**
 * @summary Trigger a full resync of the VN address mirror
 */
export const useAdminStartVnAddressSync = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStartVnAddressSync>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminStartVnAddressSync>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getAdminStartVnAddressSyncMutationOptions(options));
};
